import { createI18n } from 'vue-i18n'

const messages = {
  pt: {
    slogan: "Um lugar para compartilhar boas ideias",

    modalCarregamento: 'Por favor, aguarde...',
    
    avancar: "Avançar",
    voltar: "Voltar",
    fechar: "Fechar",
    cancelar: "Cancelar",
    carregando: "Por favor, aguarde...",

    nenhumReaEncontrado: 'Nenhum REA foi encontrado.',
    nenhumaComunidadeEncontrada: 'Nenhuma comunidade foi encontrada.',

    home: {
      cardREA: 'Acesse, reuse, crie, compartilhe',
      cardComunidades: 'Forme, reúna, participe, envolva-se',
      cardUsuarios: 'Conheça, encontre, interaja, incentive'
    },

    navbar: {
      sobreNos: 'Sobre Nós',
      faleConosco: 'Ajuda e Contato',
      entrar: 'Entrar',
      novoREA: 'Novo Recurso',
      meusREA: 'Meus REA',
      tutorial: 'Comece Aqui',
      config: 'Configurações',
      perfil: 'Perfil',
      sair: 'Sair',
      msgSaida: 'Tem certeza que deseja sair?',
      novaComunidade: 'Nova Comunidade',
      minhasComunidades: 'Minhas Comunidades',
      convites: 'Convites',
      fechar: 'Fechar',
      carregando: 'Carregando...',
      carregandoConvites: 'Carregando seus convites...',
      nenhumConvitePendente: 'Você não possui convites pendentes.',
      atualizarConvites: 'Atualizar',
      nenhumaComunidadeCriada: 'Você ainda não participa de nenhuma comunidade.',
      inicio: 'Início',
      rea: 'REA',
      membros: 'Membros',
      forum: 'Fórum',
      usuarios: 'Colaboradores',
      comunidades: 'Comunidades',
      rascunhoPendente: 'Você possui um rascunho pendente. Termine de editar ou salve o rascunho antes de fazer logout.',
      sairComunidade: 'Sair da comunidade',
      msgSairComunidade: 'Tem certeza que deseja sair da comunidade?',
      entrarOutraComunidade: 'Entrar em outra comunidade',
      msgEntrarOutraComunidade: 'Você já está em uma comunidade. Deseja sair dela e entrar nesta?',
    },

    aboutUs: {
      tituloObjetivo: 'Objetivo',
      tituloSobreNos: 'Quem somos nós?',
      tituloEducacaoAberta: 'Sobre Educação Aberta',

      textoSobreNos: '<p>O Laboratório de Computação Aplicada à Educação e Tecnologia Social Avançada (CAEd), do <a href="https://www.icmc.usp.br" class="link-custom" target="_blank">Instituto de Ciências Matemáticas e de Computação (ICMC)</a> da <a href="https://saocarlos.usp.br/" class="link-custom" target="_blank">USP São Carlos</a>, reúne pesquisadoras e pesquisadores dedicados ao desenvolvimento de tecnologias e soluções computacionais que visam a contribuir com o contínuo aprimoramento e consolidação de práticas educacionais.<p>O aquare!a, um repositório dinâmico de REA, foi concebido e desenvolvido por Fernando Cesar Balbino, com supervisão de Ellen Francine Barbosa. A versão atual contou com a participação de Diego Fernandes Lemos, como responsável pelo design da interface gráfica da aplicação.</p><p>Nossa expectativa é a de que o aquare!a seja naturalmente percebido como uma ferramenta útil, produtiva e facilitadora do exercício diário inerente aos desafios educacionais.</p>',

      textoObjetivo: '<p>O aquare!a é uma plataforma que promove práticas educacionais abertas, com foco na criação, no compartilhamento e no uso de REA.</p><p>O projeto foi inicialmente concebido para oferecer aos professores da Educação Básica uma ferramenta para a comunicação, a interação e a colaboração, com o intuito de facilitar as práticas docentes (acesso a materiais didáticos para preparação de aulas, planejamento e aplicação de atividades práticas, ideias e abordagens diferenciadas para o ensino, entre outras).</p><p>Para além disso, a experiência de uso do aquare!a evidenciou também a possibilidade de conectar educadores a estudantes de licenciatura e vice-versa, viabilizando um trabalho conjunto que agrega o exercício da profissão docente à formação inicial, ao mesmo tempo em que a comunidade em geral se beneficia com o acesso aberto a recursos educacionais de qualidade.</p><p>O aquare!a pode ser usado livremente por toda e qualquer pessoa que tenha interesse em produzir, compartilhar e reusar conhecimento, ideias e experiências educacionais. Registre-se e colabore!!!</p>',

      textoEducacaoAberta: '<p>O <a href="https://www.capetowndeclaration.org/read/" class="link-custom" target="_blank">movimento de Educação Aberta</a> combina a experiência humana de compartilhar boas ideias com a cultura interativa e colaborativa da Internet. Por isso mesmo, está fundamentado na crença de que todas as pessoas devem ter a liberdade de usar, personalizar, melhorar e redistribuir recursos educacionais sem restrições, utilizando-se de tecnologias que facilitem o compartilhamento aberto do conhecimento e a aprendizagem flexível e colaborativa.</p><p>Em outras palavras, <a href="https://www.aberta.org.br/livrorea/livro/livroREA-1edicao-mai2012.pdf#page=19" class="link-custom" target="_blank">"o movimento para uma Educação Aberta é uma tentativa de buscar alternativas sustentáveis para algumas das barreiras evidentes no que tange ao direito de uma educação de qualidade"</a>. Portanto, as propostas da Educação Aberta não devem ser adotadas como tendo um caráter "salvacionista", no sentido de oferecer soluções definitivas para os problemas e desafios da educação.</p><p>Sob uma perspectiva realista, as ações que visam à abertura da educação, especialmente as que dizem respeito ao uso de REA, podem e devem coexistir com as práticas educacionais vigentes, a fim de que a cultura aberta seja um caminho viável e significativo para educadores e aprendizes.</p>',

      cargoFernando: 'Desenvolvedor Full Stack',
      profissaoFernando: 'Professor do IFMS',
      cargoEllen: 'Supervisora do Projeto',
      profissaoEllen: 'Professora Associada do ICMC-USP',
      cargoDiego: 'Designer Web Front End',
      profissaoDiego: 'Aluno de Sistemas de Informação no ICMC-USP',
    },

    contactUs: {
      frasePrincipal: 'Precisa de ajuda com alguma coisa?',
      fraseSecundaria: 'sinta-se a vontade para nos mandar uma mensagem ou consulte o FAQ abaixo!',
      textoEmail: 'Tem uma dúvida ou sugestão? Nossa equipe está pronta para ajudar. Deixe sua mensagem e responderemos o mais rápido possível!',
      mensagemSucesso: 'Mensagem enviada com sucesso!',
      mensagemErro: 'Ocorreu um erro ao enviar o e-mail. Tente novamente mais tarde.',
      nome: 'Nome *',
      nomeAviso: 'Por favor, informe seu nome.',
      email: 'Email *',
      emailAviso: 'Por favor, informe um email válido.',
      mensagem: 'Mensagem *',
      mensagemAviso: 'Por favor, informe sua mensagem.',
      enviar: 'Enviar',
      nomePlaceholder: "Digite o seu nome",
      emailPlaceholder: "Digite o seu email",
      mensagemPlaceholder: "Digite a sua mensagem",

      pergunta1: 'O que é um REA?',
      resposta1: "Um <a href='https://www.unesco.org/en/legal-affairs/recommendation-open-educational-resources-oer?hub=785' class='link-custom' target='_blank'>REA (Recurso Educacional Aberto)</a> é qualquer material educacional que pode ser livremente utilizado, modificado e compartilhado. Eles são criados com o objetivo de promover o acesso ao conhecimento e à educação de forma aberta e colaborativa.</p>Um REA pode ser uma página explicativa sobre determinado assunto, uma figura, uma lista de exercícios, um plano de aula, um relato de experiência, um livro didático completo, vídeos, um arquivo de áudio, uma poesia, uma proposta de atividade, entre outras possibilidades que atendam a um objetivo de ensino e/ou de aprendizagem.",

      pergunta2: 'O que é uma licença aberta Creative Commons?',
      resposta2: "Qualquer material educacional pode ser um REA desde que esteja licenciado com uma licença aberta. As <a href='https://creativecommons.org/share-your-work/cclicenses/' target='_blank'>licenças abertas Creative Commons (CC)</a> são as mais conhecidas e utilizadas no movimento REA.<br><br>Uma licença CC pode ser compreendida simplesmente como um selo que é 'colado' em algum lugar do material educacional. Assim, a pessoa que o acessa pode identificar quais são os direitos e deveres de uso daquele REA.<br><br>A única obrigatoriedade comum a todas as licenças CC é o dever de se atribuir crédito ao autor da obra, justamente para que o trabalho intelectual seja valorizado.<br><br>Uma licença CC também vai determinar se o REA pode ser modificado, se pode ser usado para fins comerciais e como ele deve ser compartilhado. Existem seis tipos de licenças CC, que variam de acordo com as permissões e restrições. No aquare!a, são usadas as quatro licenças CC menos restritivas.",

      pergunta3: 'O que significam as atividades 5R?',
      resposta3: "As <a href='https://opencontent.org/blog/archives/3221' target='_blank'>atividades 5R</a> referem-se às liberdades de uso de um REA, que são:<ul><li><b>Retain</b>: o direito de <b>guardar</b> uma cópia do material.</li><li><b>Reuse</b>: o direito de <b>usar</b> o material em diferentes contextos e conforme a necessidade.</li><li><b>Revise</b>: o direito de <b>adaptar</b> o material, ou seja, modificá-lo para atender necessidades específicas.</li><li><b>Remix</b>: o direito de <b>combinar</b> diferentes materiais para criar um novo, conforme a necessidade.</li><li><b>Redistribute</b>: o direito de <b>redistribuir</b> o material, ou seja, compartilhar cópias do original ou das novas versões.</li></ul>Cada licença aberta Creative Commons vai determinar quais dessas liberdades são concedidas. Uma coisa é certa: você sempre terá o direito de guardar, usar e redistribuir um REA. É só não esquecer de atribuir crédito ao autor.",

      pergunta4: 'Para que serve o aquare!a?',
      resposta4: "O aquare!a é uma plataforma que promove práticas educacionais abertas, com foco na criação, no compartilhamento e no uso de REA para todos os níveis da Educação Básica. Ele serve para conectar educadores, estudantes e a comunidade em geral, promovendo o acesso ao conhecimento de forma colaborativa e aberta.<br><br>Existem três possibilidades para criação e compartilhamento de um REA no aquare!a:<ul><li><b>Criar conteúdo:</b> consiste na criação de um REA utilizando-se um editor disponível no próprio aquare!a. Além de texto, o REA pode conter imagens, vídeos e links para qualquer outro recurso disponível na Internet. Depois de pronto, o REA pode ser acessado no formato de uma página Web, que pode ser facilmente impressa, baixada no formato PDF, compartilhada em redes sociais, modificada e redistribuída.</li><li><b>Criar trilha de aprendizagem:</b> consiste na criação de um REA que reúne outros REA, formando uma sequência didática para o ensino e a aprendizagem gradativos de um determinado assunto. Uma trilha de aprendizagem também pode servir para reunir REA que não precisam ser considerados em sequência, mas que são relacionados entre si.</li><li><b>Upload de arquivo:</b> permite o compartilhamento de qualquer tipo de arquivo (um documento PDF, um conjunto de slides, uma planilha, etc) ou de um link para um recurso externo.</li></ul>Em qualquer uma dessas opções, você pode criar, compartilhar e reusar os mais diversos tipos de materiais educacionais. Além disso, o aquare!a oferece ferramentas para a criação de comunidades, onde é possível discutir, compartilhar experiências e colaborar na produção de novos REA.",

      pergunta5: 'Para que uma comunidade pode ser criada no aquare!a?',
      resposta5: "Criar uma comunidade no aquare!a significa organizar um espaço em que um grupo de pessoas possa se conectar em torno de interesses e objetivos comuns. Isso pode facilitar a troca de ideias e reunir esforços para que, por meio da colaboração, cada participante seja beneficiado.<br><br>Professores de uma mesma escola podem, por exemplo, criar uma comunidade para compartilhar REA sobre temas transversais. Ou professores de matemática de uma rede municipal podem elaborar um caderno didático com atividades práticas baseadas em diferentes abordagens.<br><br>Portanto, as comunidades podem ser criadas no aquare!a para discutir temas de interesse do grupo, compartilhar materiais educacionais, trocar experiências e colaborar na produção de novos REA.",

      pergunta6: 'O que são práticas educacionais abertas?',
      resposta6: "A criação de REA no aquare!a compreende a atribuição de licenças abertas que asseguram as liberdades 5R. Professores, estudantes e a comunidade em geral podem criar, compartilhar, modificar e redistribuir materiais educacionais de forma prática e intuitiva.<br><br>A interação entre os colaboradores registrados no aquare!a pode se dar por meio da comunicação direta (bate-papo) ou em comunidades.<br><br>Por isso, o aquare!a é um repositório dinâmico de REA, pois promove <a href='https://www.irrodl.org/index.php/irrodl/article/view/3096' target='_blank'>práticas educacionais abertas</a>. Isso significa dizer que o aquare!a consiste em uma tecnologia participativa e de rede social para práticas colaborativas que incluem a criação, o uso e o reuso de REA, bem como a interação, o aprendizado por pares, a construção de conhecimento e o empoderamento de educadores e aprendizes.",
    },

    login: {
      titulo: 'Educação aberta para todos. Comece sua jornada agora!',
      email: 'Digite seu email',
      senha: 'Digite sua senha',
      entrar: 'Entrar',
      alertEmailSenha: 'E-mail ou senha não cadastrados ou não ativados.',
      alertSemEmail: 'Por favor, digite o e-mail para redefinir a senha.',
      alertEmail: 'E-mail não cadastrado ou não ativado.',
      alertSenhaSucesso: 'Uma nova senha foi enviada para seu e-mail.',
      alertSenhaErro: 'Infelizmente não foi possível redefinir sua senha. Por favor, entre em contato para que possamos auxiliar.',
      lembreteSenha: 'Esqueceu a senha?',
      lembreteCadastro: 'Ainda não tem cadastro?',
      clique: 'Clique aqui!',
      criar: 'Crie sua conta!',
    },

    perfil: {
      publicados: 'Meus REA publicados',
      favoritos: 'Meus REA favoritos',
      rascunhos: 'Meus rascunhos',
    },

    formsColaborador: {
      colaborador: 'Colaborador',
      nome: 'Nome *',
      placeholderNome: 'Digite o seu nome',
      nomeAlert: 'Por favor, informe o seu nome.',
      email: 'Email *',
      placeholderEmail: "seuemail{'@'}exemplo.com",
      emailAlert: 'Por favor, informe um e-mail válido.',
      voce: 'Sobre Você *',
      placeholderVoce: 'Digite sobre você',
      voceAlert: 'Por favor, descreva-se para que outras pessoas possam conhecê-la/o.',
      ie: 'Nome da Instituição de Ensino (I.E.) *',
      placeholderIe: 'Digite o nome da I.E.',
      ieAlert: 'Por favor, informe o nome da I.E. em que você trabalha ou estuda.',
      siglaIE: 'Sigla da I.E. *',
      placeholderSiglaIe: 'Digite a sigla',
      siglaIEAlert: 'Por favor, informe a sigla do nome da I.E. em que você trabalha ou estuda.',
      rede: 'Rede de Ensino *',
      municipal: 'Municipal',
      estadual: 'Estadual',
      federal: 'Federal',
      privada: 'Privada',
      redeAlert: 'Por favor, informe a Rede de Ensino da I.E.',
      cidade: 'Cidade *',
      placeholderCidade: 'Digite o nome da cidade da I.E.',
      cidadeAlert: 'Por favor, informe a cidade de localização da I.E.',
      uf: 'UF da I.E. *',
      ufAlert: 'Por favor, informe a UF da cidade informada.',
      funcao: 'Função *',
      professor: 'Professor',
      coordenador: 'Coordenador',
      diretor: 'Diretor',
      estudante: 'Estudante',
      outra: 'Outra',
      funcaoAlert: 'Por favor, informe a sua função na I.E.',
      senha: 'Senha *',
      placeholderSenha: 'Digite a sua senha',
      senhaAlert: 'Por favor, informe a senha para acesso ao sistema.',
      confSenha: 'Confirmação de senha *',
      confSenhaAlert: 'Por favor, confirme a senha para acesso ao sistema.',
      confSenhaAlertDiferente: 'As senhas não conferem. Por favor, digite-as novamente.',
      interesse: 'Área(s) de atuação/interesse *',
      interesseAlert: 'Por favor, indique pelo menos uma área de atuação/interesse.',
      salvar: 'Salvar',
      cancelar: 'Cancelar',
      dadosAtualizados: 'Os seus dados foram atualizados!',
      atualizacaoPerfil: 'Atualização de perfil',
      modalConfirmCancelEdit: {
        titulo: 'Cancelar edição',
        mensagem: 'Tem certeza que deseja sair? Todas as alterações serão perdidas'
      },
      sucessoCadastroTitulo: "Seja bem-vinda/o ao aquare!a!",
      sucessoCadastroMensagem: "Por favor, acesse o seu e-mail para ativar o seu cadastro. Obrigado!",
      aviso: "Aviso",
      emailDuplicado: "O e-mail informado já está cadastrado.",
    },

    formsREA: {
      newResourceConteudo: 'Novo recurso / Conteúdo',
      newResourceTrilha: 'Novo recurso / Trilha de Aprendizagem',
      newResourceArquivo: 'Novo recurso / Arquivo',
      titulo: 'Título *',
      placeholderTitulo: 'Digite o título',
      tituloAlert: 'Por favor, informe o título do REA.',
      descricao: 'Descrição *',
      placeholderDescricao: 'Digite a descrição',
      descricaoAlert: 'Por favor, descreva o REA.',
      autores: 'Autor(es) *',
      autoresAlert: 'Por favor, informe pelo menos um autor.',
      tipoConteudo: 'Tipo de conteúdo *',
      tipoConteudoAlert: 'Por favor, informe o tipo do REA.',
      optionDocumentoHTML: 'Documento HTML',
      optionTrilhaAprendizagem: 'Trilha de aprendizagem',
      optionVideo: 'Vídeo',
      optionAudio: 'Arquivo de áudio',
      optionPDF: 'Arquivo PDF',
      optionTexto: 'Arquivo de texto',
      optionSoftware: 'Software',
      optionOutro: 'Outro',
      area: 'Área do conhecimento *',
      areaAlert: 'Por favor, informe a área de conhecimento a que pertence o REA.',
      optionAreaEuOutroNos: 'O eu, o outro e o nós',
      optionAreaCorpoGestos: 'Corpo, gestos e movimentos',
      optionAreaTracosSons: 'Traços, sons, cores e formas',
      optionAreaEscutaFala: 'Escuta, fala, pensamento e imaginação',
      optionAreaEspacosTempos: 'Espaços, tempos, quantidades, relações e transformações',
      optionAreaEF_Linguagens: 'Linguagens',
      optionAreaEF_Matematica: 'Matemática',
      optionAreaEF_CienciasNatureza: 'Ciências da Natureza',
      optionAreaEF_CienciasHumanas: 'Ciências Humanas',
      optionAreaEF_EnsinoReligioso: 'Ensino Religioso',
      optionAreaEM_Linguagens: 'Linguagens e suas Tecnologias',
      optionAreaEM_Matematica: 'Matemática e suas Tecnologias',
      optionAreaEM_CienciasNatureza: 'Ciências da Natureza e suas Tecnologias',
      optionAreaEM_CienciasHumanasSociais: 'Ciências Humanas e Sociais Aplicadas',
      optionAreaMultidisciplinar: 'Multidisciplinar',
      idioma: 'Idioma *',
      optionIdiomaPortugues: 'Português',
      optionIdiomaIngles: 'Inglês',
      optionIdiomaEspanhol: 'Espanhol',
      optionIdiomaOutro: 'Outro',
      idiomaAlert: 'Por favor, informe o idioma do REA.',
      palavrasChave: 'Palavras-chave *',
      placeholderPalavrasChave: 'Digite as palavras-chave',
      palavrasChaveAlert: 'Por favor, informe pelo menos uma palavra-chave.',
      licencaCC: 'Tipo de licença Creative Commons *',
      permitirUsoComercialPergunta: 'Permitir usos comerciais da sua obra?',
      sim: 'Sim',
      nao: 'Não',
      usoComercialAlert: 'Por favor, decida sobre o uso comercial do REA.',
      permitirModificacoesPergunta: 'Permitir modificações da sua obra?',
      simDesdeQueCompartilhemIgual: 'Sim, desde que outros compartilhem igual',
      modificacoesAlert: 'Por favor, decida sobre modificações do REA.',
      descCCBySa: 'Esta licença permite que outras pessoas remixem, adaptem e usem seu REA, inclusive comercialmente, desde que você seja devidamente citado/a como autor/a da versão original e os trabalhos derivados sejam licenciados sob os mesmos termos. Portanto, todos os trabalhos derivados da sua versão original também permitirão o uso comercial.',
      descCCBy: 'Esta licença permite que outras pessoas distribuam, remixem, adaptem e usem seu REA, inclusive comercialmente, desde que você seja devidamente citado/a como autor/a da versão original. Esta é a licença mais flexível e em conformidade com a cultura livre.',
      descCCByNcSa: 'Esta licença permite que outras pessoas remixem, adaptem e usem seu REA para fins não comerciais, desde que você seja devidamente citado/a como autor/a da versão original e os trabalhos derivados sejam licenciados exatamente sob os mesmos termos.',
      descCCByNc: 'Esta licença permite que outras pessoas remixem, adaptem e usem seu REA para fins não comerciais, desde que você seja devidamente citado/a como autor/a da versão original. Trabalhos derivados não precisam ser licenciados sob os mesmos termos, mas não podem permitir o uso comercial.',
      buttonCancelar: 'Cancelar',
      buttonAvancar: 'Avançar',
      confirmCancelar: 'Tem certeza de que deseja cancelar? Todo o conteúdo será perdido.'
    },    

    select: {
      conteudo: 'Criar conteúdo',
      trilha: 'Criar trilha de<br>aprendizagem',
      arquivo: 'Upload de arquivo',
    },

    search: {
      buscarREAs: 'Buscar REA',
      buscarComunidades: 'Buscar Comunidades', 
      buscarUsuarios: 'Buscar Colaboradores',
      nenhumResultado: 'Nenhum resultado encontrado',
      carregandoDados: 'Carregando dados...',
      erroCarregarREAs: 'Erro ao buscar REA',
      erroCarregarComunidades: 'Erro ao buscar comunidades',
      erroCarregarUsuarios: 'Erro ao buscar colaboradores',
      paginaAlterada: 'Página alterada para',
      abaAlterada: 'Aba alterada',
      buscaExecutada: 'Busca executada',
      totalResultados: 'Total de resultados',
      página: 'Página'
    },

    tutorial: {
      tituloComece: 'Comece Aqui',
      tituloPassos: 'Primeiros Passos',
      tituloGuia: 'Guia Completo',
      
      textoComece: 'Bem-vindo ao Aquarela! Este é o seu ponto de partida para criar e compartilhar Recursos Educacionais Abertos (REA). Aqui você aprenderá como navegar pela plataforma e criar seus primeiros conteúdos educacionais.',
      
      textoPassos: 'Siga estes passos simples para começar: 1) Crie sua conta ou faça login; 2) Explore os REA existentes para se inspirar; 3) Clique em "Novo Recurso" para criar seu primeiro conteúdo; 4) Preencha as informações básicas; 5) Adicione seu conteúdo; 6) Publique e compartilhe!',
      
      textoGuia: 'Para um guia mais detalhado, explore nossa documentação completa. Você encontrará tutoriais em vídeo, exemplos práticos e dicas para criar conteúdos educacionais de qualidade seguindo os princípios dos 5 Rs da Educação Aberta.'
    },

    profile: {
      alterarFotoPerfil: 'Alterar foto de perfil',
      convidarParaComunidade: 'Convidar',
      editarPerfil: 'Editar perfil',
      sobreMim: 'Sobre mim',
      comunidadesQueParticipo: 'Comunidades que participo',
      usuarioNaoPublicouREA: 'Este colaborador ainda não publicou nenhum REA.',
      usuarioNaoFavoritouREA: 'Este colaborador ainda não favoritou nenhum REA.',
      usuarioNaoParteComunidade: 'Este colaborador ainda não faz parte de nenhuma comunidade.',
      voceSemRascunhos: 'Você ainda não possui rascunhos salvos.',
      
      modalFoto: {
        titulo: 'Alterar foto de perfil',
        preview: 'Preview da foto',
        selecioneNovaFoto: 'Selecione uma nova foto:',
        formatosAceitos: 'Formatos aceitos: JPG, PNG, GIF. Tamanho máximo: 5MB.',
        cancelar: 'Cancelar',
        salvandoFoto: 'Salvando...',
        salvarFoto: 'Salvar foto',
        erroApenasImagens: 'Por favor, selecione apenas arquivos de imagem.',
        erroTamanhoMaximo: 'O arquivo deve ter no máximo 5MB.',
        erroSelecioneFoto: 'Por favor, selecione uma foto.',
        sucessoFotoAtualizada: 'Foto de perfil atualizada com sucesso!',
        erroArquivoGrande: 'Arquivo muito grande. Máximo permitido: 5MB.',
        erroFormatoNaoSuportado: 'Formato de arquivo não suportado.',
        erroUploadFoto: 'Erro ao fazer upload da foto. Tente novamente.'
      },
      
      modalConvite: {
        titulo: 'para uma comunidade',
        carregandoComunidades: 'Carregando suas comunidades...',
        voceSemComunidades: 'Você ainda não faz parte de nenhuma comunidade.',
        precisaSerMembro: 'Para convidar outros colaboradores, você precisa ser membro de uma comunidade.',
        selecioneComunidade: 'Selecione uma comunidade para enviar o convite:',
        nomeComunidade: 'Nome da Comunidade',
        membros: 'Membros',
        acao: 'Ação',
        convidar: 'Convidar',
        cancelar: 'Cancelar',
        fechar: 'Fechar',
        convidante: 'Convidado por',
        sucessoConviteEnviado: 'Convite enviado com sucesso para',
        erroUsuarioJaConvidado: 'Este colaborador já foi convidado ou já faz parte desta comunidade.',
        erroUsuarioNaoEncontrado: 'Colaborador ou comunidade não encontrados.',
        erroEnviarConvite: 'Erro ao enviar convite. Tente novamente.',
        erroCarregarComunidades: 'Erro ao carregar suas comunidades. Tente novamente.'
      }
    },

    notFound: {
      titulo: 'Página não encontrada... 😢',
      descricao: 'A página que você procura não foi encontrada.<br>Talvez ela tenha sido movida, excluída ou nunca tenha existido.<br>Tente voltar para a',
      paginaInicial: ' página inicial',
      ou: 'ou nos',
      mandeMensagem: 'mande uma mensagem!'
    },

    draftPreview: {
      tituloNaoDisponivel: 'Título não disponível',
      descricaoNaoDisponivel: 'Descrição não disponível',
      palavrasChave: 'Palavras-chave: ',
      autores: 'Autor(es): ',
      tipoConteudo: 'Tipo de conteúdo: ',
      areaConhecimento: 'Área do conhecimento: ',
      idioma: 'Idioma: ',
      dataPublicacao: 'Data de publicação: ',
      visualizacoes: 'Visualizações: ',
      adaptacoes: 'Adaptações: ',
      remixes: 'Remixes: ',
      licenca: 'Licença: ',
      guardar: 'Favoritar',
      adaptar: 'Adaptar',
      baixar: 'Baixar',
      compartilhar: 'Compartilhar',
      avaliar: 'Avaliar',
      adaptacoesBtn: 'Adaptações',
      conteudoNaoDisponivel: 'Conteúdo não disponível',
      trilhaAprendizado: 'Trilha de Aprendizado:',
      reaDisponivelInternet: 'Este REA está disponível no link abaixo. Clique para acessar.',
      linkRea: 'Link:',
      reaDisponivelDownload: 'Este REA está disponível apenas para download. Clique abaixo para baixar.',
      nomeArquivo: 'Arquivo:',
      nomeArquivoNaoDisponivel: 'Nome do arquivo não disponível',
      nenhumArquivoConfigurado: 'Nenhum arquivo ou URL configurado.',
      confirmacaoPublicacao: 'Após ser publicado, o REA ainda poderá ser editado ou excluído (desde que não tenha sido reutilizado por outras pessoas).\nDeseja publicá-lo agora?',
      nao: 'Não',
      sim: 'Sim',
      aguarde: 'Por favor, aguarde...',
      voltar: 'Voltar',
      excluir: 'Excluir',
      continuarEdicao: 'Excluir rascunho',
      continuar: 'Continuar edição',
      confirmarExclusao: 'Tem certeza que deseja excluir este rascunho? Esta ação não pode ser desfeita.',
      dataIndisponivel: 'Data não disponível'
    },

    cardView: {
      selecioneEstrela: "Por favor, selecione uma estrela para avaliar.",
      palavrasChave: 'Palavras-chave: ',
      autores: 'Autor(es): ',
      publicadoPor: 'Publicado por: ',
      tipoConteudo: 'Tipo de conteúdo: ',
      areaConhecimento: 'Área do conhecimento: ',
      idioma: 'Idioma: ',
      dataPublicacao: 'Data de publicação: ',
      visualizacoes: 'Visualizações: ',
      avaliacoes: "Avaliações: ",
      adaptacoes: 'Adaptações: ',
      remixes: 'Remixes: ',
      licenca: 'Licença: ',
      guardar: 'Favoritar',
      adaptar: 'Adaptar',
      imprimir: 'Imprimir',
      compartilhar: 'Compartilhar',
      avaliar: 'Avaliar',
      adaptacoesBtn: 'Adaptações',
      adicionarFavoritos: 'Adicionar aos meus favoritos',
      trilhaAprendizado: 'Trilha de Aprendizado:',
      reaDisponivelInternet: 'Este REA está disponível no link abaixo. Clique para acessar.',
      linkRea: 'Link:',
      reaDisponivelDownload: 'Este REA está disponível apenas para download. Clique abaixo para baixar.',
      nomeArquivo: 'Arquivo:',
      adaptacoesDesteRea: 'Adaptações deste REA',
      aguarde: 'Por favor, aguarde...',
      oQueVoceAchou: 'O que você achou deste recurso?',
      escrevaComentario: 'Escreva seu comentário aqui...',
      cancelar: 'Cancelar',
      enviar: 'Enviar',
      facaLoginAvaliar: 'Faça login para avaliar este recurso',
      entreContaAvaliar: 'Entre na sua conta para deixar uma avaliação e ajudar a comunidade.',
      reaAdicionadoFavoritos: 'REA adicionado aos seus favoritos!',
      licencaNaoEspecificada: 'Licença não especificada',
      licencaTexto: 'Licença',
      licencaDescricao: 'Este REA está licenciado sob',
      licencaInfoVisitar: 'Para mais informações sobre esta licença, visite:',
      confiraRecurso: 'Olá! Confira este recurso educacional aberto:',
      selecionaEstrela: 'Por favor, selecione uma estrela para avaliar.',
      // Novas traduções para comunidades
      adicionarAComunidade: 'Adicionar REA a uma Comunidade',
      carregandoComunidades: 'Carregando suas comunidades...',
      voceSemComunidades: 'Você ainda não faz parte de nenhuma comunidade.',
      precisaSerMembro: 'Para adicionar REA, você precisa ser membro de uma comunidade.',
      selecioneComunidade: 'Selecione uma comunidade para adicionar este REA:',
      adicionar: 'Vincular',
      reaAdicionadoComSucesso: 'REA adicionado com sucesso à comunidade',
      reaJaAssociado: 'Este REA já está associado a esta comunidade.',
      comunidadeOuREANaoEncontrado: 'Comunidade ou REA não encontrados.',
      erroAdicionarREA: 'Erro ao adicionar REA à comunidade. Tente novamente.',
      // Edição e exclusão de REA
      editar: "Editar",
      excluir: "Excluir",
      confirmarExclusaoTitulo: "Excluir REA",
      confirmarExclusaoMensagem: "Tem certeza de que deseja excluir este REA? Esta ação não pode ser desfeita.",
      reaExcluidoSucesso: "REA excluído com sucesso!",
      erroExcluirRea: "Não foi possível excluir o REA.",
      editarRea: "Editar REA",
      quotaExcedidaAdaptacao: 'Não foi possível adaptar este REA porque o tamanho do conteúdo excede o limite de armazenamento do navegador.',
      quotaExcedidaEdicao: 'Não foi possível editar este REA porque o conteúdo excede o limite de armazenamento local do navegador.'
    },

    uploadREA: {
      titulo: 'Novo upload de arquivo',
      cliqueSelecionarArquivo: 'Clique para selecionar um arquivo ou arraste e solte aqui...',
      campoDesabilitadoUrl: 'Remova a URL para habiliar esta área e enviar um arquivo.',
      ou: 'ou',
      placeholderLink: 'Informe aqui o link para o arquivo',
      campoDesabilitadoArquivo: 'Remova o arquivo para habilitar esta área e inserir uma URL.',
      erroArquivoOuLink: 'Por favor, faça o upload de um arquivo ou informe o link em que ele pode ser acessado.',
      voltar: 'Voltar',
      cancelar: 'Cancelar',
      avancar: 'Avançar',
      baixandoArquivo: 'Baixando arquivo...',
      tamanhoMaximo: 'O tamanho máximo permitido para o arquivo é de 20 MB.',
      confirmarCancelamento: 'Deseja realmente cancelar?',
      erroArquivoInvalido: 'Erro: Arquivo inválido. Por favor, selecione o arquivo novamente.',
      removerArquivo: 'Remover',
    },

    trilhaAprendizagem: {
      adicionePeloMenosUmREA: 'Adicione pelo menos um REA à trilha antes de avançar.',
      reaJaAdicionado: 'Este REA já foi adicionado à trilha. Não é possível adicionar REA duplicados.',
      reasDuplicadosDetectados: 'Foram detectados REA duplicados na trilha. Remova os duplicados antes de continuar.',
      erroAdicionarREA: 'Erro ao adicionar o REA à trilha. Tente novamente.',
      confirmarCancelamento: 'Tem certeza de que deseja cancelar? Todo o conteúdo será perdido.',
      licencasIncompativeis: 'Foram encontrados REA com licenças incompatíveis com a licença escolhida para esta trilha de aprendizagem ({licenca}). Somente REA com as seguintes licenças podem ser adicionados: {licencas}.',
      licencasCompativeis: 'Você atribuiu a licença {licenca} à trilha de aprendizagem. Somente REA com licenças compatíveis ({licencas}) serão exibidos nos resultados da busca.',
      toastCardAdicionado: "REA adicionado à trilha de aprendizagem!",
    },

    tinyEditor: {
      voltar: 'Voltar',
      cancelar: 'Confirmar cancelamento',
      avancar: 'Avançar',
      aviso: 'Aviso',
      editorNaoPodeEstarVazio: 'O editor de texto não pode estar vazio.',
      confirmarCancelamento: 'Tem certeza de que deseja cancelar? Todo o conteúdo será perdido.',
      pecaAjudaIA: "Peça ajuda a uma IA!",
      digitePerguntaIA: "Digite sua pergunta para a IA aqui...",
      gerarTexto: "Gerar texto",
    },

    postPreview: {
      confirmacaoPublicacaoTitulo: 'Confirmação de publicação',
      palavrasChave: 'Palavras-chave: ',
      definirImagemCapa: 'Definir imagem de capa',
      autores: 'Autor(es): ',
      autoresOriginaisRemovidos: 'Autores originais removidos: ',
      deveIncluirAutoresOriginais: 'Você deve incluir todos os autores originais desta adaptação para poder salvar ou publicar.',
      tipoConteudo: 'Tipo de conteúdo: ',
      areaConhecimento: 'Área do conhecimento: ',
      idioma: 'Idioma: ',
      dataPublicacao: 'Data de publicação: ',
      visualizacoes: 'Visualizações: ',
      adaptacoes: 'Adaptações: ',
      remixes: 'Remixes: ',
      licenca: 'Licença: ',
      licencaOriginalNaoAlterada: 'Licença original (não pode ser alterada em adaptações)',
      guardar: 'Favoritar',
      adaptar: 'Adaptar',
      baixar: 'Baixar',
      compartilhar: 'Compartilhar',
      avaliar: 'Avaliar',
      adaptacoesBtn: 'Adaptações',
      trilhaAprendizado: 'Trilha de Aprendizado:',
      reaDisponivelInternet: 'Este REA está disponível na internet. Clique abaixo para acessar.',
      linkRea: 'Link:',
      reaDisponivelDownload: 'Este REA está disponível apenas para download. Clique abaixo para baixar.',
      nomeArquivo: 'Arquivo:',
      arquivoSelecionado: 'Arquivo selecionado',
      nenhumArquivoConfigurado: 'Nenhum arquivo ou URL configurado.',
      confirmacaoPublicacao: 'Após ser publicado, o REA ainda poderá ser editado ou excluído (desde que não tenha sido reutilizado por outras pessoas).\nDeseja publicá-lo agora?',
      nao: 'Não',
      sim: 'Sim',
      aguarde: 'Por favor, aguarde...',
      voltar: 'Voltar',
      cancelar: 'Cancelar',
      salvarRascunho: 'Salvar rascunho',
      publicar: 'Publicar',
      confirmarCancelamento: 'Tem certeza de que deseja cancelar? Todo o conteúdo será perdido.',
      naoSalvarRascunhoAutores: 'Não é possível salvar como rascunho. Você deve incluir todos os autores originais desta adaptação antes de salvar.',
      naoPublicarAutores: 'Não é possível publicar. Você deve incluir todos os autores originais desta adaptação antes de publicar.',
      rascunhoAtualizadoSucesso: 'Rascunho atualizado com sucesso!',
      rascunhoSalvoSucesso: 'Rascunho salvo com sucesso!',
      reaSalvoSucesso: 'Parabéns! Você publicou um REA e acaba de contribuir com uma educação de qualidade.',
      erroArquivoInvalido: 'Erro: Nenhum arquivo ou URL válido encontrado. Por favor, selecione um arquivo ou insira uma URL.',
      rascunhoDesabilitadoPublicado: "Não é possível salvar rascunho para um REA já publicado."
    },

    formsComunidade: {
      novaComunidade: 'Nova Comunidade',
      campoImagem: 'CAMPO DA IMAGEM',
      nome: 'Nome *',
      placeholderNome: 'Digite o nome da comunidade...',
      nomeAlert: 'Por favor, informe o nome da comunidade.',
      descricao: 'Descrição *',
      descricaoAlert: 'Por favor, informe a descrição da comunidade.',
      criarComunidade: 'Criar Comunidade',
      comunidadeCriadaSucesso: 'Comunidade criada com sucesso!',
      removerCapa: 'Remover capa',
    },

    formsViewREA: {
      comunidade: 'Comunidade',
      carregandoNomeComunidade: 'Carregando nome da comunidade...',
      removerAssociacaoComunidade: 'Remover associação com a comunidade',
      reaAdicionadoComunidade: 'Este REA será adicionado à comunidade que você está navegando. Você pode remover esta associação clicando no "×".',
      licencaAdaptacao: 'Licença (Adaptação)',
      esteEAdaptacao: 'Esta é uma adaptação de um REA existente.',
      licencaOriginalPreservada: 'A licença original será preservada automaticamente. Não é possível alterar a licença em adaptações.',
      licencaOriginalRea: 'Licença original do REA que está sendo adaptado.',
      licencaSeraMantida: 'A licença original requer que a adaptação seja licenciada sob os mesmos termos.',
      licencaPodeSerAlteradaLivremente: 'A licença original é CC BY, portanto você pode escolher qualquer outra licença para esta adaptação.',
      licencaDeveManterNCComOpcaoSA: 'A licença original é CC BY-NC. Sua adaptação deve manter NC, mas você pode incluir SA se desejar.',
      nomeComMaisDe50Caracteres: 'Nome com mais de 50 caracteres; dê 2 cliques sobre o nome para editar',
      nomeJaIncluido: 'Nome já incluído',
      tagComMaisDe50Caracteres: 'Tag com mais de 50 caracteres; dê 2 cliques sobre a tag para editar',
      tagJaIncluido: 'Tag já incluído',
      desejaRemoverAssociacaoComunidade: 'Deseja remover a associação deste REA com a comunidade?'
    },

    usuarioDisplay: {
      nenhumUsuarioEncontrado: 'Nenhum colaborador foi encontrado.',
      facaPesquisaEncontrarUsuarios: 'Faça uma pesquisa para encontrar colaboradores na plataforma.'
    },

    modalCardSearch: {
      adicionar: 'Adicionar REA',
    },

    searchBar: {
      placeholder: 'Digite palavras isoladas ou expressões entre aspas',
      aplicarFiltros: 'Aplicar Filtros',
      limparFiltros: 'Limpar Filtros',
      licencas: 'Licenças:',
      areas: 'Áreas:',
      funcoes: 'Funções:',
      interesses: 'Interesses:',
      licencaBy: 'BY',
      licencaBySa: 'BY-SA',
      licencaByNc: 'BY-NC',
      licencaByNcSa: 'BY-NC-SA',
      educacaoInfantil: 'Educação Infantil',
      ensinoFundamental: 'Ensino Fundamental',
      ensinoMedio: 'Ensino Médio',
      areaEiEuOutroNos: 'O eu, o outro e o nós',
      areaEiCorpoGestos: 'Corpo, gestos e movimentos',
      areaEiTracosSons: 'Traços, sons, cores e formas',
      areaEiEscutaFala: 'Escuta, fala, pensamento e imaginação',
      areaEiEspacosTempos: 'Espaços, tempos, quantidades, relações e transformações',
      areaEfLinguagens: 'Linguagens',
      areaEfMatematica: 'Matemática',
      areaEfCienciasNatureza: 'Ciências da Natureza',
      areaEfCienciasHumanas: 'Ciências Humanas',
      areaEfEnsinoReligioso: 'Ensino Religioso',
      areaEmLinguagens: 'Linguagens e suas Tecnologias',
      areaEmMatematica: 'Matemática e suas Tecnologias',
      areaEmCienciasNatureza: 'Ciências da Natureza e suas Tecnologias',
      areaEmCienciasHumanas: 'Ciências Humanas e Sociais Aplicadas',
      areaMultidisciplinar: 'Multidisciplinar',
      funcaoProfessor: 'Professor',
      funcaoCoordenador: 'Coordenador',
      funcaoEstudante: 'Estudante',
      funcaoDiretor: 'Diretor',
      funcaoOutro: 'Outro',
    },

    reaDisplayComunidade: {
      buscarREAsNestaComunidade: 'Buscar REA nesta comunidade...',
      nenhumREAEncontrado: 'Nenhum REA foi encontrado.',
      tenteOutraVez: 'Tente outra vez!',
      comunidadeSemREAs: 'Esta comunidade ainda não possui REA.',
      escopo: 'Escopo da Busca:',
      apenasREAsComunidade: 'Apenas REA desta comunidade',
      todosREAs: 'Todos os REA da plataforma'
    },

    membroDisplay: {
      apenasMembrosComunidade: 'Apenas membros desta comunidade',
      todosMembros: 'Todos os membros da plataforma',
      pesquisarMembroPeloNome: 'Pesquisar membro pelo nome...',
      pesquisar: 'Pesquisar',
      aplicarFiltros: 'Aplicar Filtros',
      limparFiltros: 'Limpar Filtros',
      funcoes: 'Funções:',
      interesses: 'Interesses:',
      professor: 'Professor',
      coordenador: 'Coordenador',
      estudante: 'Estudante',
      diretor: 'Diretor',
      nenhumMembroEncontrado: 'Nenhum membro foi encontrado.',
      comunidadeSemMembros: 'Esta comunidade ainda não possui membros.'
    },

    comunidadeCard: {
      capaComunidade: 'Capa da comunidade',
      criadaEm: 'Criada em',
      membros: 'membros',
      membro: 'membro'
    },

    cards: {
      autor: 'Autor: ',
      data: 'Data: ',
      licenca: 'Licença: ',
      visualizacoes: 'Visualizações: ',
      imagemAleatoria: 'Imagem aleatória'
    },

    trilhaSearchHeader: {
      resultadoPesquisa: 'Resultados da pesquisa',
      buscaAvancada: 'Busca Avançada',
      carregandoREAsCompativeis: 'Carregando REA compatíveis...',
      resultadosEncontrados: 'resultado(s) encontrados para',
      resultadosEncontradosTotal: 'resultados encontrados',
    },

    trilhaSearchBar: {
      procurarREA: 'Procurar um REA...',
      licencaFixa: 'Licença Fixa',
      licencaBaseDraft: 'Baseada nas configurações da sua trilha',
    },

    contentCardREATrilhadeAprendizagem: {
      palavrasChave: 'Palavras-chave: ',
      capaREA: 'Capa do REA',
      autores: 'Autor(es): ',
      tipoConteudo: 'Tipo de conteúdo: ',
      areaConhecimento: 'Área do conhecimento: ',
      idioma: 'Idioma: ',
      dataPublicacao: 'Data de publicação: ',
      visualizacoes: 'Visualizações: ',
      adaptacoes: 'Adaptações: ',
      remixes: 'Remixes: ',
      licenca: 'Licença: ',
      trilhaAprendizado: 'Trilha de Aprendizado: ',
      reaDisponivelInternet: 'Este REA está disponível no link abaixo. Clique para acessar.',
      linkREA: 'Link: ',
      reaDisponivelDownload: 'Este REA está disponível apenas para download. Clique abaixo para baixar.',
      nomeArquivo: 'Arquivo: ',
    },

    cardsTrilhadeAprendizagem: {
      capaREA: 'Capa do REA',
      autor: 'Autor: ',
      data: 'Data: ',
      visualizacoes: 'Visualizações: '
    },

    cardsDisplayTrilhadeAprendizagem: {
      nenhumREACompativel: 'Nenhum REA é compatível com as licenças selecionadas.',
      nenhumREAEncontrado: 'Nenhum REA foi encontrado para a busca de',
      tenteOutraVez: 'Tente outra vez!',
    },

    searchHeader: {
      tituloREA: 'Procurar REA',
      tituloComunidade: 'Procurar comunidades',
      tituloUsuario: 'Procurar colaboradores',
      facaPesquisa: 'Faça uma pesquisa!',
      resultadosEncontrados: 'resultado(s) encontrados para',
      resultadosEncontradosTotal: 'resultados encontrados',
      filtrosAtivos: "filtros",
      filtroLicenca: "licenças",
      filtroArea: "áreas",
      filtroFuncao: "funções",
      filtroInteresse: "interesses"
    },

    comunidade: {
      nome: 'Nome',
      status: 'Status',
      criacao: 'Criação',
      acoes: 'Ações',
      ativa: 'Ativa',
      inativa: 'Inativa',
      desativar: 'Desativar',
      reativar: 'Reativar',
      bemVindo: 'Bem-vindo à comunidade!',
      descricaoBemVindo: 'Explore os recursos e conecte-se com outros membros.',
      alterarImagemCapa: 'Alterar imagem de capa',
      modalCapa: {
        titulo: 'Alterar capa da comunidade',
        cancelar: 'Cancelar',
        confirmar: 'Confirmar'
      },
      modalEdicao: {
        titulo: 'Editar Comunidade',
        nomeComunidade: 'Nome da Comunidade',
        descricaoComunidade: 'Descrição da Comunidade',
        comunidadeAtiva: 'Comunidade Ativa:',
        cancelar: 'Cancelar',
        salvarAlteracoes: 'Salvar Alterações'
      },
      criadoPor: 'Criada por: ',
      criadoEm: 'Criada em: ',
      membros: ' membros',
      membro: ' membro',
      topicos: ' tópicos de discussão',
      editarComunidade: 'Editar comunidade',
      enviando: 'Enviando...',
      pedirParaEntrar: 'Pedir para ser membro',
      saindo: 'Saindo...',
      sairDaComunidade: 'Deixar de ser membro',
      listaREAs: 'REA da Comunidade',
      descricaoREAs: 'Explore os recursos educacionais desta comunidade.',
      tutorialREAs: "Para adicionar um REA a esta comunidade, acesse o REA desejado e utilize a opção 'Vincular'.",
      listaMembros: 'Membros da Comunidade',
      tutorialMembros: 'Para convidar um novo membro, entre no respectivo perfil e utilize a opção "Convidar para uma comunidade".',
      descricaoMembros: 'Conheça os membros desta comunidade.',
      verPedidos: 'Ver pedidos pendentes',
      modalPedidos: {
        titulo: 'Pedidos Pendentes',
        carregandoPedidos: 'Carregando pedidos...',
        nenhumPedidoPendente: 'Não há pedidos pendentes.',
        solicitante: 'Solicitante',
        dataPedido: 'Data do Pedido',
        aceitar: 'Aceitar',
        recusar: 'Recusar',
        pedido: 'Pedido de',
      },
      forumComunidade: 'Fórum da Comunidade',
      descricaoForum: 'Participe das discussões da comunidade.',
      topico: 'Tópico',
      posts: 'Posts',
      ultimoPost: 'Último Post',
      novoTopico: 'Novo Tópico',
      modalTopico: {
        titulo: 'Criar Novo Tópico',
        nomeTopico: 'Nome do Tópico',
        cancelar: 'Cancelar',
        criar: 'Criar',
        editarTitulo: 'Editar tópico',
        salvar: 'Salvar alterações',
      },
      modalPosts: {
        tituloPrefix: 'Posts do tópico',
        data: 'Data',
        autor: 'Autor',
        mensagem: 'Mensagem',
        nenhumPost: 'Nenhum post encontrado.',
        novaMensagem: 'Nova Mensagem',
        postar: 'Postar',
        excluirTitulo: "Excluir mensagem",
        excluirMensagem: "Tem certeza de que deseja excluir esta mensagem?",
        editarPost: 'Editar mensagem',
        excluirPost: 'Excluir mensagem',
        editarTitulo: "Editar mensagem",
        carregarMaisMensagens: "Carregar mais mensagens",
        carregandoMaisMensagens: "Carregando...",
      },
      confirmacoes: {
        desativarComunidade: 'Deseja realmente desativar a comunidade',
        reativarComunidade: 'Deseja realmente reativar a comunidade',
        sairComunidade: 'Tem certeza que deseja sair desta comunidade?'
      },
      alertas: {
        pedidoEnviadoSucesso: 'Pedido enviado com sucesso!',
        pedidoJaEnviado: 'Você já enviou um pedido para esta comunidade.',
        comunidadeNaoEncontrada: 'Comunidade não encontrada.',
        erroPedido: 'Erro ao enviar pedido. Tente novamente.',
        saiuComSucesso: 'Você saiu da comunidade com sucesso.',
        membroNaoEncontrado: 'Membro não encontrado.',
        erroSair: 'Erro ao sair da comunidade. Tente novamente.',
        pedidoAceitoSucesso: 'aceito com sucesso!',
        pedidoRecusado: 'recusado.',
        erroAceitarPedido: 'Erro ao aceitar pedido. Tente novamente.',
        erroRecusarPedido: 'Erro ao recusar pedido. Tente novamente.',
        conviteAceitoSucesso: 'Convite aceito com sucesso!',
        erroAceitarConvite: 'Erro ao aceitar convite. Tente novamente.',
        erroRecusarConvite: 'Erro ao recusar convite. Tente novamente.',
        erroSalvarAlteracoes: 'Erro ao salvar alterações. Tente novamente.',
        comunidadeDesativada: 'Esta comunidade foi desativada.',
        topicoAtualizado: 'Tópico atualizado com sucesso.',
        erroAtualizarTopico: 'Não foi possível atualizar o tópico.',
        topicoExcluido: 'Tópico excluído com sucesso.',
        erroExcluirTopico: 'Não foi possível excluir o tópico.',
        topicoComMensagensEdicao: "Este tópico já possui mensagens e não pode mais ser editado.",
        topicoComMensagensExclusao: "Este tópico já possui mensagens e não pode ser excluído.",
        topicoNaoEncontrado: "Tópico não encontrado ou já removido.",
        erroExcluirMensagem: "Não foi possível excluir a mensagem.",
        tempoExclusaoExpirado: "O prazo (10 minutos) para excluir esta mensagem já expirou.",
        postExcluidoSucesso: "Mensagem excluída com sucesso.",
        erroExcluirPostPermissao: "Você não tem permissão para excluir esta mensagem.",
        tempoEdicaoExpirado: "O prazo (10 minutos) para editar esta mensagem já expirou.",
        erroEditarMensagem: "Não foi possível editar a mensagem.",
        postEditadoSucesso: "Mensagem atualizada com sucesso.",
        erroEditarPostPermissao: "Você não tem permissão para editar esta mensagem.",
        mensagemVazia: "A mensagem não pode ficar vazia.",
        erroCarregarMaisMensagens: "Não foi possível carregar mais mensagens.",
      },
      editarTopico: "Editar tópico",
      excluirTopico: "Excluir tópico",
      excluirTopicoTitulo: 'Excluir tópico',
      excluirTopicoMensagem: 'Tem certeza de que deseja excluir este tópico? Esta ação não pode ser desfeita.',
      diasAtras: 'dia(s) atrás',
      horasAtras: 'hora(s) atrás',
      minAtras: 'min atrás',
      agora: 'agora mesmo',
    },

    chat: {
      placeholderMensagem: "Digite sua mensagem...",
      enviar: "Enviar",
      naoFazMaisParte: "Você não faz mais parte desta sala. O envio de novas mensagens está desabilitado.",
      saiu: "{nome} saiu",
      foiRemovido: "{nome} foi removido",
      foiAdicionado: "{nome} foi adicionado",
      usuarioGenerico: "Usuário"
    },
    chatApp: {
      criarSala: "Criar sala",
      novaConversa: "Nova conversa",
      editarSala: "Editar sala",
      excluirSala: "Excluir sala",

      confirmacaoExclusaoTitulo: "Confirmação",
      confirmacaoExclusaoMensagem: "Tem certeza que deseja apagar esta conversa? Esta ação não pode ser desfeita.",

      cancelar: "Cancelar",
      excluir: "Excluir",

      naoTemPermissao: "Você não tem permissão para excluir esta sala.",
      erroExcluir: "Não foi possível excluir. Tente novamente.",

      selecionarOuIniciar: "Selecione uma sala ou inicie uma conversa."
    },
    iniciarConversaModal: {
      titulo: "Iniciar conversa",
      placeholderBusca: "Digite um nome ou palavra-chave",
      nenhumUsuario: "Nenhum usuário encontrado.",
      conversar: "Conversar"
    },
    gerenciarSala: {
      tituloCriar: "Criar nova sala",
      avisoSomenteLeitura: "Você não faz mais parte desta sala. Você pode visualizar o histórico, mas não pode editá-la.",
      avisoConcorrencia: "A lista de participantes foi atualizada por outro usuário.",

      labelNomeSala: "Nome da sala",
      placeholderNomeSala: "Digite o nome da sala",

      labelBusca: "Buscar colaboradores",
      placeholderBusca: "Digite um nome...",

      btnAdicionar: "Adicionar",
      btnRemover: "Remover",

      nenhumSelecionado: "Nenhum colaborador selecionado.",

      btnCancelar: "Cancelar",
      btnCriarSala: "Criar Sala",
      btnSalvarAlteracoes: "Salvar Alterações"
    }
  },
  en: {
    slogan: "A place for sharing good ideas",

    modalCarregamento: 'Please wait...',
    
    nenhumReaEncontrado: 'No OER found.',
    nenhumaComunidadeEncontrada: 'No community was found.',

    avancar: "Next",
    voltar: "Back",
    fechar: "Close",
    cancelar: "Cancel",
    carregando: "Please wait...",

    home: {
      cardREA: 'Access, reuse, create, share',
      cardComunidades: 'Build, gather, join, get involved',
      cardUsuarios: 'Discover, find, interact, encourage'
    },

    navbar: {
      sobreNos: 'About Us',
      faleConosco: 'Help & Contact',
      entrar: 'Login',
      novoREA: 'New Resource',
      meusREA: 'My OER',
      tutorial: 'Start Here',
      config: 'Settings',
      perfil: 'Profile',
      sair: 'Logout',
      msgSaida: 'Are you sure you want to logout?',
      novaComunidade: 'New Community',
      minhasComunidades: 'My Communities',
      convites: 'Invitations',
      fechar: 'Close',
      carregando: 'Loading...',
      carregandoConvites: 'Loading your invitations...',
      nenhumConvitePendente: 'You have no pending invitations.',
      atualizarConvites: 'Refresh',
      nenhumaComunidadeCriada: 'You are not part of any community yet.',
      inicio: 'Home',
      rea: 'OER',
      membros: 'Members',
      forum: 'Forum',
      usuarios: 'Contributors',
      comunidades: 'Communities',
      rascunhoPendente: 'You have a pending draft. Finish editing or save the draft before logging out.',
      sairComunidade: 'Leave community',
      msgSairComunidade: 'Are you sure you want to leave the community?',
      entrarOutraComunidade: 'Join another community',
      msgEntrarOutraComunidade: 'You are already in a community. Do you want to leave it and join this one?',
    },

    aboutUs: {
      tituloObjetivo: 'Objective',
      tituloSobreNos: 'Who are we?',
      tituloEducacaoAberta: 'About Open Education',

      textoSobreNos: '<p>The Laboratory of Applied Computing for Education and Advanced Social Technology (CAEd) at the <a href="https://www.icmc.usp.br" class="link-custom" target="_blank">Institute of Mathematics and Computer Science (ICMC)</a> of the <a href="https://saocarlos.usp.br/" class="link-custom" target="_blank">University of São Paulo, São Carlos campus (USP São Carlos)</a>, brings together researchers dedicated to developing technologies and computational solutions aimed at contributing to the continuous improvement and consolidation of educational practices.</p><p>The aquare!a, a dynamic repository of OER, was conceived and developed by Fernando Cesar Balbino, under the supervision of Ellen Francine Barbosa. The current version included the participation of Diego Fernandes Lemos, who was responsible for the application’s graphical interface design.</p><p>Our expectation is that aquare!a will naturally be perceived as a useful, productive, and facilitating tool for the daily exercise inherent to educational challenges.</p>',

      textoObjetivo: '<p>aquare!a is a platform that promotes open educational practices, focusing on the creation, sharing, and use of OER.</p><p>The project was initially conceived to provide Basic Education teachers with a tool for communication, interaction, and collaboration, aiming to facilitate teaching practices (access to teaching materials for lesson preparation, planning and implementation of practical activities, ideas and different approaches to teaching, among others).</p><p>Moreover, the use experience of aquare!a also revealed the possibility of connecting educators with undergraduate teaching students and vice versa, enabling joint work that links the practice of the teaching profession to initial training, while at the same time benefiting the general community through open access to quality educational resources.</p><p>aquare!a can be freely used by anyone interested in producing, sharing, and reusing knowledge, ideas, and educational experiences. Register and collaborate!!!</p>',

      textoEducacaoAberta: '<p>The <a href="https://www.capetowndeclaration.org/read/" class="link-custom" target="_blank">Open Education movement</a> combines the human experience of sharing good ideas with the interactive and collaborative culture of the Internet. It is therefore grounded in the belief that all people should have the freedom to use, customize, improve, and redistribute educational resources without restrictions, using technologies that facilitate the open sharing of knowledge and flexible, collaborative learning.</p><p>In other words, <a href="https://www.aberta.org.br/livrorea/livro/livroREA-1edicao-mai2012.pdf#page=19" class="link-custom" target="_blank">"the movement for Open Education is an attempt to seek sustainable alternatives to some of the evident barriers regarding the right to quality education"</a>. Therefore, the proposals of Open Education should not be adopted as having a "salvationist" character, in the sense of offering definitive solutions to the problems and challenges of education.</p><p>From a realistic perspective, actions aimed at opening up education, especially those concerning the use of OER, can and should coexist with current educational practices, so that open culture becomes a viable and meaningful path for educators and learners.</p>',

      cargoFernando: 'Full Stack Developer',
      profissaoFernando: 'Professor at IFMS',
      cargoEllen: 'Project Supervisor',
      profissaoEllen: 'Associate Professor at ICMC-USP',
      cargoDiego: 'Front End Web Designer',
      profissaoDiego: 'Information Systems Student at ICMC-USP',
    },

    contactUs: {
      frasePrincipal: 'Need help with something?',
      fraseSecundaria: 'feel free to send us a message or check the FAQ below!',
      textoEmail: 'Have a question or suggestion? Our team is ready to help. Leave your message and we\'ll respond as soon as possible!',
      mensagemSucesso: 'Message sent successfully!',
      mensagemErro: 'An error occurred while sending the email. Please try again later.',
      nome: 'Name *',
      nomeAviso: 'Please enter your name.',
      email: 'Email *',
      emailAviso: 'Please enter a valid email.',
      mensagem: 'Message *',
      mensagemAviso: 'Please enter your message.',
      enviar: 'Send',
      nomePlaceholder: "Type your name",
      emailPlaceholder: "Type your email",
      mensagemPlaceholder: "Type your message",

      pergunta1: 'What is an OER?',
      resposta1: "An <a href='https://www.unesco.org/en/legal-affairs/recommendation-open-educational-resources-oer?hub=785' class='link-custom' target='_blank'>OER (Open Educational Resource)</a> is any educational material that can be freely used, modified, and shared. They are created with the aim of promoting access to knowledge and education in an open and collaborative way.<br><br>An OER can be an explanatory page on a given subject, a figure, a set of exercises, a lesson plan, an experience report, a complete textbook, videos, an audio file, a poem, an activity proposal, among other possibilities that serve a teaching and/or learning objective.",

      pergunta2: 'What is an open Creative Commons license?',
      resposta2: "Any educational material can be an OER as long as it is licensed under an open license. The <a href='https://creativecommons.org/share-your-work/cclicenses/' target='_blank'>Creative Commons (CC) open licenses</a> are the most well-known and widely used in the OER movement.<br><br>A CC license can be understood simply as a 'seal' that is applied somewhere on the educational material. This way, the person accessing it can identify what the rights and responsibilities of using that OER are.<br><br>The only requirement common to all CC licenses is the duty to give credit to the author of the work, ensuring that intellectual work is valued.<br><br>A CC license will also determine whether the OER can be modified, used for commercial purposes, and how it should be shared. There are six types of CC licenses, varying according to permissions and restrictions. On aquare!a, the four least restrictive CC licenses are used.",

      pergunta3: 'What do the 5R activities mean?',
      resposta3: "The <a href='https://opencontent.org/blog/archives/3221' target='_blank'>5R activities</a> refer to the freedoms of using an OER, which are:<ul><li><b>Retain</b>: the right to <b>keep</b> a copy of the material.</li><li><b>Reuse</b>: the right to <b>use</b> the material in different contexts and as needed.</li><li><b>Revise</b>: the right to <b>adapt</b> the material, that is, to modify it to meet specific needs.</li><li><b>Remix</b>: the right to <b>combine</b> different materials to create a new one, as needed.</li><li><b>Redistribute</b>: the right to <b>share</b> the material, i.e., distribute copies of the original or modified versions.</li></ul>Each open Creative Commons license determines which of these freedoms are granted. One thing is certain: you will always have the right to keep, use, and redistribute an OER. Just don’t forget to give credit to the author.",

      pergunta4: 'What is aquare!a for?',
      resposta4: "Aquare!a is a platform that promotes open educational practices, focusing on the creation, sharing, and use of OER for all levels of basic education. It serves to connect educators, students, and the community in general, promoting access to knowledge in a collaborative and open way.<br><br>There are three possibilities for creating and sharing an OER on aquare!a:<ul><li><b>Create content:</b> consists of creating an OER using an editor available within aquare!a. In addition to text, the OER can contain images, videos, and links to any other resource available on the internet. Once ready, the OER can be accessed as a web page, which can be easily printed, downloaded as a PDF, shared on social media, modified, and redistributed.</li><li><b>Create a learning path:</b> consists of creating an OER that brings together other OERs, forming a didactic sequence for gradual teaching and learning of a given subject. A learning path can also serve to group OERs that don’t need to be considered in sequence, but are related, such as an explanatory text, a list of exercises, and a lesson plan.</li><li><b>Upload a file:</b> allows the sharing of any type of file (a PDF document, a set of slides, a spreadsheet, etc.) or a link to an external resource (for example, a website or an open book).</li></ul>In any of these options, you can create, share, and reuse a wide variety of educational materials designed for different audiences and teaching and learning contexts.<br><br>In addition, aquare!a offers tools for creating communities, where it is possible to discuss, share experiences, and collaborate in producing new OER.",

      pergunta5: 'Why create a community on aquare!a?',
      resposta5: "Creating a community on aquare!a means organizing a space where a group of people can connect around shared interests and goals. This can facilitate the exchange of ideas and combine efforts so that, through collaboration, each participant benefits in their educational activities.<br><br>Teachers from the same school can, for example, create a community to share OER on cross-cutting topics that cover different subjects. Or math teachers from a municipal network can create a community to develop a teaching guide with practical activities based on different approaches and teaching experiences.<br><br>Therefore, communities can be created on aquare!a to discuss topics of interest, share educational materials, exchange experiences, and collaborate in producing new OER.",

      pergunta6: 'What are open educational practices?',
      resposta6: "Creating OER on aquare!a involves assigning open licenses that ensure the 5R freedoms. Teachers, students, and the community in general can create, share, modify, and redistribute educational materials in a practical and intuitive way.<br><br>Interaction between registered contributors on aquare!a can take place through direct communication (chat) or in organized spaces for discussion and experience sharing (communities).<br><br>That’s why aquare!a is a dynamic repository of OER, as it promotes <a href='https://www.irrodl.org/index.php/irrodl/article/view/3096' target='_blank'>open educational practices</a>. This means that aquare!a functions as a participatory, social-network-like technology for collaborative practices, including the creation, use, and reuse of OER, as well as interaction, peer learning, knowledge building, and the empowerment of educators and learners.",
    },

    login: {
      titulo: 'Open education for everyone. Start your journey now!',
      email: 'Enter your email',
      senha: 'Enter your password',
      entrar: 'Login',
      alertEmailSenha: 'Email or password not registered or not activated.',
      alertSemEmail: 'Please enter the email to reset the password.',
      alertEmail: 'Email not registered or not activated.',
      alertSenhaSucesso: 'A new password has been sent to your email.',
      alertSenhaErro: 'Unfortunately it was not possible to reset your password. Please contact us so we can help.',
      lembreteSenha: 'Forgot password?',
      lembreteCadastro: 'Don\'t have an account yet?',
      clique: 'Click here!',
      criar: 'Create your account!',
    },

    perfil: {
      publicados: 'My published OER',
      favoritos: 'My favorite OER',
      rascunhos: 'My drafts',
    },

    formsColaborador: {
      colaborador: 'Collaborator',
      nome: 'Name *',
      placeholderNome: 'Enter your name',
      nomeAlert: 'Please enter your name.',
      email: 'Email *',
      placeholderEmail: "youremail{'@'}exemplo.com",
      emailAlert: 'Please enter a valid email.',
      voce: 'About You *',
      placeholderVoce: 'Tell us about yourself',
      voceAlert: 'Please describe yourself so other people can get to know you.',
      ie: 'Educational Institution (E.I.) Name *',
      placeholderIe: 'Enter the E.I. name',
      ieAlert: 'Please enter the name of the E.I. where you work or study.',
      siglaIE: 'E.I. Acronym *',
      placeholderSiglaIe: 'Enter the acronym',
      siglaIEAlert: 'Please enter the acronym of the E.I. where you work or study.',
      rede: 'Education Network *',
      municipal: 'Municipal',
      estadual: 'State',
      federal: 'Federal',
      privada: 'Private',
      redeAlert: 'Please enter the Education Network of the E.I.',
      cidade: 'City *',
      placeholderCidade: 'Enter the city name of the E.I.',
      cidadeAlert: 'Please enter the location city of the E.I.',
      uf: 'State/Province of E.I. *',
      ufAlert: 'Please enter the state/province of the informed city.',
      funcao: 'Role *',
      professor: 'Teacher',
      coordenador: 'Coordinator',
      diretor: 'Director',
      estudante: 'Student',
      outra: 'Other',
      funcaoAlert: 'Please enter your role in the E.I.',
      senha: 'Password *',
      placeholderSenha: 'Enter your password',
      senhaAlert: 'Please enter the password to access the system.',
      confSenha: 'Password confirmation *',
      confSenhaAlert: 'Please confirm the password to access the system.',
      confSenhaAlertDiferente: 'Passwords don\'t match. Please enter them again.',
      interesse: 'Area(s) of activity/interest *',
      interesseAlert: 'Please indicate at least one area of activity/interest.',
      salvar: 'Save',
      cancelar: 'Cancel',
      dadosAtualizados: 'Your data has been updated!',
      atualizacaoPerfil: 'Profile update',
      modalConfirmCancelEdit: {
        titulo: 'Cancel editing',
        mensagem: 'Are you sure you want to exit? All changes will be lost.'
      },
      sucessoCadastroTitulo: "Welcome to aquare!a!",
      sucessoCadastroMensagem: "Please check your email to activate your account. Thank you!",
      aviso: "Warning",
      emailDuplicado: "The provided email is already registered.",
    },

    formsREA: {
      newResourceConteudo: 'New resource / Content',
      newResourceTrilha: 'New resource / Learning path',
      newResourceArquivo: 'New resource / File',
      titulo: 'Title *',
      placeholderTitulo: 'Enter the title',
      tituloAlert: 'Please enter the OER title.',
      descricao: 'Description *',
      placeholderDescricao: 'Enter the description',
      descricaoAlert: 'Please describe the OER.',
      autores: 'Author(s) *',
      autoresAlert: 'Please enter at least one author.',
      tipoConteudo: 'Content type *',
      tipoConteudoAlert: 'Please enter the OER type.',
      optionDocumentoHTML: 'HTML Document',
      optionTrilhaAprendizagem: 'Learning path',
      optionVideo: 'Video',
      optionAudio: 'Audio file',
      optionPDF: 'PDF file',
      optionTexto: 'Text file',
      optionSoftware: 'Software',
      optionOutro: 'Other',
      area: 'Knowledge area *',
      areaAlert: 'Please enter the knowledge area to which the OER belongs.',
      optionAreaEuOutroNos: 'Me, the other and us',
      optionAreaCorpoGestos: 'Body, gestures and movements',
      optionAreaTracosSons: 'Traços, sons, cores e formas',
      optionAreaEscutaFala: 'Listening, speaking, thinking and imagination',
      optionAreaEspacosTempos: 'Spaces, times, quantities, relationships and transformations',
      optionAreaEF_Linguagens: 'Languages',
      optionAreaEF_Matematica: 'Mathematics',
      optionAreaEF_CienciasNatureza: 'Natural Sciences',
      optionAreaEF_CienciasHumanas: 'Human Sciences',
      optionAreaEF_EnsinoReligioso: 'Religious Education',
      optionAreaEM_Linguagens: 'Languages and Technologies',
      optionAreaEM_Matematica: 'Mathematics and Technologies',
      optionAreaEM_CienciasNatureza: 'Natural Sciences and Technologies',
      optionAreaEM_CienciasHumanasSociais: 'Human and Applied Social Sciences',
      optionAreaMultidisciplinar: 'Multidisciplinary',
      idioma: 'Language *',
      optionIdiomaPortugues: 'Portuguese',
      optionIdiomaIngles: 'English',
      optionIdiomaEspanhol: 'Spanish',
      optionIdiomaOutro: 'Other',
      idiomaAlert: 'Please enter the OER language.',
      palavrasChave: 'Keywords *',
      placeholderPalavrasChave: 'Enter the keywords',
      palavrasChaveAlert: 'Please enter at least one keyword.',
      licencaCC: 'Creative Commons license type *',
      permitirUsoComercialPergunta: 'Allow commercial uses of your work?',
      sim: 'Yes',
      nao: 'No',
      usoComercialAlert: 'Please decide about commercial use of the OER.',
      permitirModificacoesPergunta: 'Allow modifications of your work?',
      simDesdeQueCompartilhemIgual: 'Yes, as long as others share alike',
      modificacoesAlert: 'Please decide about modifications of the OER.',
      descCCBySa: 'This license allows others to remix, adapt and use your OER, including commercially, as long as you are properly credited as the author of the original version and derivative works are licensed under the same terms. Therefore, all derivative works from your original version will also allow commercial use.',
      descCCBy: 'This license allows others to distribute, remix, adapt and use your OER, including commercially, as long as you are properly credited as the author of the original version. This is the most flexible license and in accordance with free culture.',
      descCCByNcSa: 'This license allows others to remix, adapt and use your OER for non-commercial purposes, as long as you are properly credited as the author of the original version and derivative works are licensed under exactly the same terms.',
      descCCByNc: 'This license allows others to remix, adapt and use your OER for non-commercial purposes, as long as you are properly credited as the author of the original version. Derivative works do not need to be licensed under the same terms, but cannot allow commercial use.',
      buttonCancelar: 'Cancel',
      buttonAvancar: 'Next',
      confirmCancelar: 'Are you sure you want to cancel? All content will be lost.'
    },    

    select: {
      conteudo: 'Create content',
      trilha: 'Create learning<br>path',
      arquivo: 'File upload',
    },

    search: {
      buscarREAs: 'Search OER',
      buscarComunidades: 'Search Communities',
      buscarUsuarios: 'Search Contributors',
      nenhumResultado: 'No results found',
      carregandoDados: 'Loading data...',
      erroCarregarREAs: 'Error loading OER',
      erroCarregarComunidades: 'Error loading communities',
      erroCarregarUsuarios: 'Error loading contributors',
      paginaAlterada: 'Page changed to',
      abaAlterada: 'Tab changed',
      buscaExecutada: 'Search executed',
      totalResultados: 'Total results',
      página: 'Page'
    },

    tutorial: {
      tituloComece: 'Start Here',
      tituloPassos: 'First Steps',
      tituloGuia: 'Complete Guide',
      
      textoComece: 'Welcome to Aquarela! This is your starting point to create and share Open Educational Resources (OER). Here you will learn how to navigate the platform and create your first educational content.',
      
      textoPassos: 'Follow these simple steps to get started: 1) Create your account or log in; 2) Explore existing OER for inspiration; 3) Click "New Resource" to create your first content; 4) Fill in basic information; 5) Add your content; 6) Publish and share!',
      
      textoGuia: 'For a more detailed guide, explore our complete documentation. You will find video tutorials, practical examples and tips for creating quality educational content following the principles of the 5 Rs of Open Education.'
    },

    profile: {
      alterarFotoPerfil: 'Change profile picture',
      convidarParaComunidade: 'Invite',
      editarPerfil: 'Edit profile',
      sobreMim: 'About me',
      comunidadesQueParticipo: 'Communities I participate in',
      usuarioNaoPublicouREA: 'This contributor has not published any OER yet.',
      usuarioNaoFavoritouREA: 'This contributor has not favorited any OER yet.',
      usuarioNaoParteComunidade: 'This contributor is not part of any community yet.',
      voceSemRascunhos: 'You don\'t have any saved drafts yet.',
      
      modalFoto: {
        titulo: 'Change profile picture',
        preview: 'Photo preview',
        selecioneNovaFoto: 'Select a new photo:',
        formatosAceitos: 'Accepted formats: JPG, PNG, GIF. Maximum size: 5MB.',
        cancelar: 'Cancel',
        salvandoFoto: 'Saving...',
        salvarFoto: 'Save photo',
        erroApenasImagens: 'Please select only image files.',
        erroTamanhoMaximo: 'File must be maximum 5MB.',
        erroSelecioneFoto: 'Please select a photo.',
        sucessoFotoAtualizada: 'Profile picture updated successfully!',
        erroArquivoGrande: 'File too large. Maximum allowed: 5MB.',
        erroFormatoNaoSuportado: 'File format not supported.',
        erroUploadFoto: 'Error uploading photo. Please try again.'
      },
      
      modalConvite: {
        titulo: 'to a community',
        carregandoComunidades: 'Loading your communities...',
        voceSemComunidades: 'You are not part of any community yet.',
        precisaSerMembro: 'To invite other contributors, you need to be a member of a community.',
        selecioneComunidade: 'Select a community to send the invitation:',
        nomeComunidade: 'Community Name',
        membros: 'Members',
        acao: 'Action',
        convidar: 'Invite',
        cancelar: 'Cancel',
        fechar: 'Close',
        convidante: 'Invited by',
        sucessoConviteEnviado: 'Invitation sent successfully to',
        erroUsuarioJaConvidado: 'This contributor has already been invited or is already part of this community.',
        erroUsuarioNaoEncontrado: 'Contributor or community not found.',
        erroEnviarConvite: 'Error sending invitation. Please try again.',
        erroCarregarComunidades: 'Error loading your communities. Please try again.'
      }
    },

    notFound: {
      titulo: 'Page not found... 😢',
      descricao: 'The page you are looking for was not found.<br>Maybe it was moved, deleted or never existed.<br>Try going back to the',
      paginaInicial: ' home page',
      ou: 'or',
      mandeMensagem: 'send us a message!'
    },

    draftPreview: {
      tituloNaoDisponivel: 'Title not available',
      descricaoNaoDisponivel: 'Description not available',
      palavrasChave: 'Keywords: ',
      autores: 'Author(s): ',
      tipoConteudo: 'Content type: ',
      areaConhecimento: 'Knowledge area: ',
      idioma: 'Language: ',
      dataPublicacao: 'Publication date: ',
      visualizacoes: 'Views: ',
      adaptacoes: 'Adaptations: ',
      remixes: 'Remixes: ',
      licenca: 'License: ',
      guardar: 'Favorite',
      adaptar: 'Adapt',
      baixar: 'Download',
      compartilhar: 'Share',
      avaliar: 'Rate',
      adaptacoesBtn: 'Adaptations',
      conteudoNaoDisponivel: 'Content not available',
      trilhaAprendizado: 'Learning Path:',
      reaDisponivelInternet: 'This OER is available at the link below. Click to access',
      linkRea: 'Link:',
      reaDisponivelDownload: 'This OER is only available for download. Click below to download.',
      nomeArquivo: 'File:',
      nomeArquivoNaoDisponivel: 'File name not available',
      nenhumArquivoConfigurado: 'No file or URL configured.',
      confirmacaoPublicacao: 'After being published, the OER can still be edited or deleted (as long as it has not been reused by other people).\nDo you want to publish it now?',
      nao: 'No',
      sim: 'Yes',
      aguarde: 'Please wait...',
      voltar: 'Back',
      excluir: 'Delete',
      continuarEdicao: 'Delete draft',
      continuar: 'Continue editing',
      confirmarExclusao: 'Are you sure you want to delete this draft? This action cannot be undone.',
      dataIndisponivel: 'Date not available'
    },

    cardView: {
      selecioneEstrela: "Please select a star to rate.",
      palavrasChave: 'Keywords: ',
      autores: 'Author(s): ',
      publicadoPor: 'Published by: ',
      tipoConteudo: 'Content type: ',
      areaConhecimento: 'Knowledge area: ',
      idioma: 'Language: ',
      dataPublicacao: 'Publication date: ',
      visualizacoes: 'Views: ',
      avaliacoes: "Ratings: ",
      adaptacoes: 'Adaptations: ',
      remixes: 'Remixes: ',
      licenca: 'License: ',
      guardar: 'Favorite',
      adaptar: 'Adapt',
      imprimir: 'Print',
      compartilhar: 'Share',
      avaliar: 'Rate',
      adaptacoesBtn: 'Adaptations',
      adicionarFavoritos: 'Add to my favorites',
      trilhaAprendizado: 'Learning Path:',
      reaDisponivelInternet: 'This OER is available at the link below. Click to access',
      linkRea: 'Link:',
      reaDisponivelDownload: 'This OER is only available for download. Click below to download.',
      nomeArquivo: 'File:',
      adaptacoesDesteRea: 'Adaptations of this OER',
      aguarde: 'Please wait...',
      oQueVoceAchou: 'What did you think of this resource?',
      escrevaComentario: 'Write your comment here...',
      cancelar: 'Cancel',
      enviar: 'Submit',
      facaLoginAvaliar: 'Login to rate this resource',
      entreContaAvaliar: 'Log into your account to leave a review and help the community.',
      reaAdicionadoFavoritos: 'OER added to your favorites!',
      licencaNaoEspecificada: 'License not specified',
      licencaTexto: 'License',
      licencaDescricao: 'This OER is licensed under',
      licencaInfoVisitar: 'For more information about this license, visit:',
      confiraRecurso: 'Hello! Check out this open educational resource:',
      // New translations for communities
      adicionarAComunidade: 'Add OER to a Community',
      carregandoComunidades: 'Loading your communities...',
      voceSemComunidades: 'You are not part of any community yet.',
      precisaSerMembro: 'To add OERs, you need to be a member of a community.',
      selecioneComunidade: 'Select a community to add this OER:',
      adicionar: 'Add',
      reaAdicionadoComSucesso: 'OER successfully added to community',
      reaJaAssociado: 'This OER is already associated with this community.',
      comunidadeOuREANaoEncontrado: 'Community or OER not found.',
      erroAdicionarREA: 'Error adding OER to community. Please try again.',
      selecionaEstrela: 'Please select a star rating before submitting your review.',
      // Edição e exclusão de REA
      editar: "Edit",
      excluir: "Delete",
      confirmarExclusaoTitulo: "Delete OER",
      confirmarExclusaoMensagem: "Are you sure you want to delete this OER? This action cannot be undone.",
      reaExcluidoSucesso: "OER deleted successfully!",
      erroExcluirRea: "Unable to delete the OER.",
      editarRea: "Edit OER",
      quotaExcedidaAdaptacao: 'It was not possible to adapt this OER because the content size exceeds the browser\'s storage limit.',
      quotaExcedidaEdicao: 'It was not possible to edit this OER because the content exceeds the browser\'s local storage limit.'
    },

    uploadREA: {
      titulo: 'New file upload',
      cliqueSelecionarArquivo: 'Click to select a file or drag and drop here...',
      campoDesabilitadoUrl: 'Remove the URL to enable this area and upload a file.',
      ou: 'or',
      placeholderLink: 'Enter the file link here',
      campoDesabilitadoArquivo: 'Remove the file to enable this area and insert a URL.',
      erroArquivoOuLink: 'Please upload a file or enter the link where it can be accessed.',
      voltar: 'Back',
      cancelar: 'Cancel',
      avancar: 'Next',
      baixandoArquivo: 'Downloading file...',
      tamanhoMaximo: 'The maximum allowed file size is 20 MB.',
      confirmarCancelamento: 'Do you really want to cancel?',
      erroArquivoInvalido: 'Error: Invalid file. Please select the file again.',
      removerArquivo: 'Remove',
    },

    trilhaAprendizagem: {
      adicionePeloMenosUmREA: 'Add at least one OER to the path before proceeding.',
      reaJaAdicionado: 'This REA has already been added to the path. Cannot add duplicate OER.',
      reasDuplicadosDetectados: 'Duplicate OER detected in the path. Remove duplicates before continuing.',
      erroAdicionarREA: 'Error adding OER to path. Please try again.',
      confirmarCancelamento: 'Are you sure you want to cancel? All content will be lost.',
      licencasIncompativeis: 'OER with licenses incompatible with the license chosen for this learning path ({licenca}) were found. Only resources with the following licenses can be included: {licencas}.',
      licencasCompativeis: 'You have assigned the license {licenca} to the learning path. Only OER with compatible licenses ({licencas}) will be displayed in the search results.',
      toastCardAdicionado: "OER added to the learning path!",
    },

    tinyEditor: {
      voltar: 'Back',
      cancelar: 'Confirm cancellation',
      avancar: 'Next',
      aviso: 'Warning',
      editorNaoPodeEstarVazio: 'The text editor cannot be empty.',
      confirmarCancelamento: 'Are you sure you want to cancel? All content will be lost.',
      pecaAjudaIA: "Ask an AI for help!",
      digitePerguntaIA: "Type your question for the AI here...",
      gerarTexto: "Generate text",
    },

    postPreview: {
      confirmacaoPublicacaoTitulo: 'Publication confirmation',
      palavrasChave: 'Keywords: ',
      definirImagemCapa: 'Set cover image',
      autores: 'Author(s): ',
      autoresOriginaisRemovidos: 'Original authors removed: ',
      deveIncluirAutoresOriginais: 'You must include all original authors of this adaptação to be able to save or publish.',
      tipoConteudo: 'Content type: ',
      areaConhecimento: 'Knowledge area: ',
      idioma: 'Language: ',
      dataPublicacao: 'Publication date: ',
      visualizacoes: 'Views: ',
      adaptacoes: 'Adaptations: ',
      remixes: 'Remixes: ',
      licenca: 'License: ',
      licencaOriginalNaoAlterada: 'Original license (cannot be changed in adaptations)',
      guardar: 'Favorite',
      adaptar: 'Adapt',
      baixar: 'Download',
      compartilhar: 'Share',
      avaliar: 'Rate',
      adaptacoesBtn: 'Adaptations',
      trilhaAprendizado: 'Learning Path:',
      reaDisponivelInternet: 'This OER is available at the link below. Click to access',
      linkRea: 'Link:',
      reaDisponivelDownload: 'This OER is only available for download. Click below to download.',
      nomeArquivo: 'File:',
      arquivoSelecionado: 'Selected file',
      nenhumArquivoConfigurado: 'No file or URL configured.',
      confirmacaoPublicacao: 'After being published, the OER can still be edited or deleted (as long as it has not been reused by other people).\nDo you want to publish it now?',
      nao: 'No',
      sim: 'Yes',
      aguarde: 'Please wait...',
      voltar: 'Back',
      cancelar: 'Cancel',
      salvarRascunho: 'Save draft',
      publicar: 'Publish',
      confirmarCancelamento: 'Are you sure you want to cancel? All content will be lost.',
      naoSalvarRascunhoAutores: 'Cannot save as draft. You must include all original authors of this adaptation before saving.',
      naoPublicarAutores: 'Cannot publish. You must include all original authors of this adaptation before publishing.',
      rascunhoAtualizadoSucesso: 'Draft updated successfully!',
      rascunhoSalvoSucesso: 'Draft saved successfully!',
      reaSalvoSucesso: 'Congratulations! You have published an OER and just contributed to quality education.',
      erroArquivoInvalido: 'Error: No valid file or URL found. Please select a file or enter a URL.',
      rascunhoDesabilitadoPublicado: "It is not possible to save a draft for an already published OER."
    },

    formsComunidade: {
      novaComunidade: 'New Community',
      campoImagem: 'IMAGE FIELD',
      nome: 'Name *',
      placeholderNome: 'Enter the community name...',
      nomeAlert: 'Please enter the community name.',
      descricao: 'Description *',
      descricaoAlert: 'Please enter the community description.',
      criarComunidade: 'Create Community',
      comunidadeCriadaSucesso: 'Community created successfully!',
      removerCapa: 'Remove cover image',
    },

    formsViewREA: {
      comunidade: 'Community',
      carregandoNomeComunidade: 'Loading community name...',
      removerAssociacaoComunidade: 'Remove association with community',
      reaAdicionadoComunidade: 'This OER will be added to the community you are browsing. You can remove this association by clicking the "×".',
      licencaAdaptacao: 'License (Adaptation)',
      esteEAdaptacao: 'This is an adaptation of an existing OER.',
      licencaOriginalPreservada: 'The original license will be preserved automatically. It is not possible to change the license in adaptations.',
      licencaOriginalRea: 'Original license of the OER being adapted.',
      licencaSeraMantida: 'The original license requires that the adaptation be licensed under the same terms.',
      licencaPodeSerAlteradaLivremente: 'The original license is CC BY, so you may choose any other license for this adaptation.',
      licencaDeveManterNCComOpcaoSA: 'The original license is CC BY-NC. Your adaptation must keep NC, but you may include SA if you wish.',
      nomeComMaisDe50Caracteres: 'Name with more than 50 characters; double-click on the name to edit',
      nomeJaIncluido: 'Name already included',
      tagComMaisDe50Caracteres: 'Tag with more than 50 characters; double-click on the tag to edit',
      tagJaIncluido: 'Tag already included',
      desejaRemoverAssociacaoComunidade: 'Do you want to remove the association of this OER with the community?'
    },

    usuarioDisplay: {
      nenhumUsuarioEncontrado: 'No contributors was found.',
      facaPesquisaEncontrarUsuarios: 'Search to find contributors on the platform.'
    },

    modalCardSearch: {
      adicionar: 'Add OER',
    },

    searchBar: {
      placeholder: 'Type individual words or phrases in quotation marks',
      aplicarFiltros: 'Apply Filters',
      limparFiltros: 'Clear Filters',
      licencas: 'Licenses:',
      areas: 'Areas:',
      funcoes: 'Roles:',
      interesses: 'Interests:',
      licencaBy: 'BY',
      licencaBySa: 'BY-SA',
      licencaByNc: 'BY-NC',
      licencaByNcSa: 'BY-NC-SA',
      educacaoInfantil: 'Elementary School',
      ensinoFundamental: 'Middle School',
      ensinoMedio: 'High School',
      areaEiEuOutroNos: 'Me, the other and us',
      areaEiCorpoGestos: 'Body, gestures and movements',
      areaEiTracosSons: 'Traces, sounds, colors and forms',
      areaEiEscutaFala: 'Listening, speaking, thinking and imagination',
      areaEiEspacosTempos: 'Spaces, times, quantities, relationships and transformations',
      areaEfLinguagens: 'Languages',
      areaEfMatematica: 'Mathematics',
      areaEfCienciasNatureza: 'Natural Sciences',
      areaEfCienciasHumanas: 'Human Sciences',
      areaEfEnsinoReligioso: 'Religious Education',
      areaEmLinguagens: 'Languages and Technologies',
      areaEmMatematica: 'Mathematics and Technologies',
      areaEmCienciasNatureza: 'Natural Sciences and Technologies',
      areaEmCienciasHumanas: 'Human and Applied Social Sciences',
      areaMultidisciplinar: 'Multidisciplinary',
      funcaoProfessor: 'Teacher',
      funcaoCoordenador: 'Coordinator',
      funcaoEstudante: 'Student',
      funcaoDiretor: 'Director',
      funcaoOutro: 'Other',
    },

    reaDisplayComunidade: {
      buscarREAsNestaComunidade: 'Search OER in this community...',
      nenhumREAEncontrado: 'No OER was found.',
      tenteOutraVez: 'Try again!',
      comunidadeSemREAs: 'This community does not have OER yet.',
      escopo: 'Search Scope:',
      apenasREAsComunidade: 'Only OER from this community',
      todosREAs: 'All OER from the platform'
    },

    membroDisplay: {
      apenasMembrosComunidade: 'Only members of this community',
      todosMembros: 'All platform members',
      pesquisarMembroPeloNome: 'Search member by name...',
      pesquisar: 'Search',
      aplicarFiltros: 'Apply Filters',
      limparFiltros: 'Clear Filters',
      funcoes: 'Roles:',
      interesses: 'Interests:',
      professor: 'Teacher',
      coordenador: 'Coordinator',
      estudante: 'Student',
      diretor: 'Director',
      nenhumMembroEncontrado: 'No members found with the applied search criteria.',
      comunidadeSemMembros: 'This community does not have members yet.'
    },

    comunidadeCard: {
      capaComunidade: 'Community cover',
      criadaEm: 'Created on',
      membros: 'members',
      membro: 'member'
    },

    cards: {
      autor: 'Author: ',
      data: 'Date: ',
      visualizacoes: 'Views: ',
      licenca: 'License: ',
      imagemAleatoria: 'Random image'
    },

    trilhaSearchHeader: {
      resultadoPesquisa: 'Search results',
      buscaAvancada: 'Advanced Search',
      carregandoREAsCompativeis: 'Loading compatible OER...',
      resultadosEncontrados: 'result(s) found for',
      resultadosEncontradosTotal: 'results found'
    },

    trilhaSearchBar: {
      procurarREA: 'Search for an OER...',
      licencaFixa: 'Fixed License',
      licencaBaseDraft: 'Based on your trail settings',
    },

    contentCardREATrilhadeAprendizagem: {
      palavrasChave: 'Keywords: ',
      capaREA: 'OER cover',
      autores: 'Author(s): ',
      tipoConteudo: 'Content type: ',
      areaConhecimento: 'Knowledge area: ',
      idioma: 'Language: ',
      dataPublicacao: 'Publication date: ',
      visualizacoes: 'Views: ',
      adaptacoes: 'Adaptations: ',
      remixes: 'Remixes: ',
      licenca: 'License: ',
      trilhaAprendizado: 'Learning Path: ',
      reaDisponivelInternet: 'This OER is available at the link below. Click to access',
      linkREA: 'Link: ',
      reaDisponivelDownload: 'This OER is only available for download. Click below to download.',
      nomeArquivo: 'File: ',
    },

    cardsTrilhadeAprendizagem: {
      capaREA: 'OER cover',
      autor: 'Author: ',
      data: 'Date: ',
      visualizacoes: 'Views: '
    },

    cardsDisplayTrilhadeAprendizagem: {
      nenhumREACompativel: 'No OER is compatible with the selected licenses.',
      nenhumREAEncontrado: 'No OER was found for the search of',
      tenteOutraVez: 'Try again!',
    },

    searchHeader: {
      tituloREA: 'Search OER',
      tituloComunidade: 'Search communities',
      tituloUsuario: 'Search contributors',
      facaPesquisa: 'Make a search!',
      resultadosEncontrados: 'result(s) found for',
      resultadosEncontradosTotal: 'results found',
      filtrosAtivos: "filters",
      filtroLicenca: "licenses",
      filtroArea: "areas",
      filtroFuncao: "roles",
      filtroInteresse: "interests"
    },

    comunidade: {
      nome: 'Name',
      status: 'Status',
      criacao: 'Creation',
      acoes: 'Actions',
      ativa: 'Active',
      inativa: 'Inactive',
      desativar: 'Deactivate',
      reativar: 'Reactivate',
      bemVindo: 'Welcome to the community!',
      descricaoBemVindo: 'Explore resources and connect with other members.',
      alterarImagemCapa: 'Change cover image',
      modalCapa: {
        titulo: 'Change community cover',
        cancelar: 'Cancel',
        confirmar: 'Confirm'
      },
      modalEdicao: {
        titulo: 'Edit Community',
        nomeComunidade: 'Community Name',
        descricaoComunidade: 'Community Description',
        comunidadeAtiva: 'Active Community:',
        cancelar: 'Cancel',
        salvarAlteracoes: 'Save Changes'
      },
      criadoPor: 'Created by: ',
      criadoEm: 'Created on: ',
      membros: ' members',
      membro: ' member',
      topicos: ' discussion topics',
      editarComunidade: 'Edit community',
      enviando: 'Sending...',
      pedirParaEntrar: 'Request to join',
      saindo: 'Leaving...',
      sairDaComunidade: 'Leave membership',
      listaREAs: 'Community OER',
      descricaoREAs: 'Explore the educational resources of this community.',
      tutorialREAs: "To add an OER to this community, go to the desired OER and use the 'Link' option.",
      listaMembros: 'Community Members',
      tutorialMembros: 'To invite a new member, go to their profile and use the "Invite to a community" option.',
      descricaoMembros: 'Meet the members of this community.',
      verPedidos: 'View pending requests',
      modalPedidos: {
        titulo: 'Pending Requests',
        carregandoPedidos: 'Loading requests...',
        nenhumPedidoPendente: 'No pending requests.',
        solicitante: 'Applicant',
        dataPedido: 'Request Date',
        aceitar: 'Accept',
        recusar: 'Decline',
        pedido: 'Request from'
      },
      forumComunidade: 'Community Forum',
      descricaoForum: 'Participate in community discussions.',
      topico: 'Topic',
      posts: 'Posts',
      ultimoPost: 'Last Post',
      novoTopico: 'New Topic',
      modalTopico: {
        titulo: 'Create New Topic',
        nomeTopico: 'Topic Name',
        cancelar: 'Cancel',
        criar: 'Create',
        editarTitulo: 'Edit topic',
        salvar: 'Save changes',
      },
      modalPosts: {
        tituloPrefix: 'Posts for topic',
        data: 'Date',
        autor: 'Author',
        mensagem: 'Message',
        nenhumPost: 'No posts found.',
        novaMensagem: 'New Message',
        postar: 'Post',
        excluirTitulo: "Delete message",
        excluirMensagem: "Are you sure you want to delete this message?",
        editarPost: 'Edit message',
        excluirPost: 'Delete message',
        editarTitulo: "Edit message",
        carregarMaisMensagens: "Load more messages",
        carregandoMaisMensagens: "Loading...",
      },
      confirmacoes: {
        desativarComunidade: 'Do you really want to deactivate the community',
        reativarComunidade: 'Do you really want to reactivate the community',
        sairComunidade: 'Are you sure you want to leave this community?'
      },
      alertas: {
        pedidoEnviadoSucesso: 'Request sent successfully!',
        pedidoJaEnviado: 'You have already sent a request to this community.',
        comunidadeNaoEncontrada: 'Community not found.',
        erroPedido: 'Error sending request. Please try again.',
        saiuComSucesso: 'You left the community successfully.',
        membroNaoEncontrado: 'Member not found.',
        erroSair: 'Error leaving the community. Please try again.',
        pedidoAceitoSucesso: 'accepted successfully!',
        pedidoRecusado: 'declined.',
        erroAceitarPedido: 'Error accepting request. Please try again.',
        erroRecusarPedido: 'Error declining request. Please try again.',
        conviteAceitoSucesso: 'Invitation accepted successfully!',
        erroAceitarConvite: 'Error accepting invitation. Please try again.',
        erroRecusarConvite: 'Error declining invitation. Please try again.',
        erroSalvarAlteracoes: 'Error saving changes. Please try again.',
        comunidadeDesativada: 'This community has been deactivated.',
        topicoAtualizado: 'Topic successfully updated.',
        erroAtualizarTopico: 'The topic could not be updated.',
        topicoExcluido: 'Topic successfully deleted.',
        erroExcluirTopico: 'The topic could not be deleted.',
        topicoComMensagensEdicao: "This topic already has messages and can no longer be edited.",
        topicoComMensagensExclusao: "This topic already has messages and cannot be deleted.",
        topicoNaoEncontrado: "Topic not found or already removed.",
        erroExcluirMensagem: "The message could not be deleted.",
        erroExcluirMensagem: "Could not delete the message.",
        tempoExclusaoExpirado: "The time limit (10 minutes) to delete this message has already expired.",
        postExcluidoSucesso: "Message deleted successfully.",
        erroExcluirPostPermissao: "You do not have permission to delete this message.",
        tempoEdicaoExpirado: "The time limit (10 minutes) to edit this message has already expired.",
        erroEditarMensagem: "Could not edit the message.",
        postEditadoSucesso: "Message updated successfully.",
        erroEditarPostPermissao: "You do not have permission to edit this message.",
        mensagemVazia: "The message cannot be empty.",
        erroCarregarMaisMensagens: "Could not load more messages.",
      },
      editarTopico: "Edit topic",
      excluirTopico: "Delete topic",
      excluirTopicoTitulo: 'Delete topic',
      excluirTopicoMensagem: 'Are you sure you want to delete this topic? This action cannot be undone.',
      diasAtras: 'day(s) ago',
      horasAtras: 'hour(s) ago',
      minAtras: 'min ago',
      agora: 'just now',
    },

    chat: {
      placeholderMensagem: "Type your message...",
      enviar: "Send",
      naoFazMaisParte: "You are no longer part of this room. Sending messages is disabled.",
      saiu: "{nome} left",
      foiRemovido: "{nome} was removed",
      foiAdicionado: "{nome} was added",
      usuarioGenerico: "User"
    },
    chatApp: {
      criarSala: "Create room",
      novaConversa: "New conversation",
      editarSala: "Edit room",
      excluirSala: "Delete room",

      confirmacaoExclusaoTitulo: "Confirmation",
      confirmacaoExclusaoMensagem: "Are you sure you want to delete this conversation? This action cannot be undone.",

      cancelar: "Cancel",
      excluir: "Delete",

      naoTemPermissao: "You do not have permission to delete this room.",
      erroExcluir: "Could not delete. Try again.",

      selecionarOuIniciar: "Select a room or start a conversation."
    },
    iniciarConversaModal: {
      titulo: "Start conversation",
      placeholderBusca: "Type a name or keyword",
      nenhumUsuario: "No users found.",
      conversar: "Chat"
    },
    gerenciarSala: {
      tituloCriar: "Create new room",
      avisoSomenteLeitura: "You are no longer a member of this room. You can view the chat history but cannot make changes.",
      avisoConcorrencia: "The participant list was updated by another user.",

      labelNomeSala: "Room name",
      placeholderNomeSala: "Enter the room name",

      labelBusca: "Search collaborators",
      placeholderBusca: "Type a name...",

      btnAdicionar: "Add",
      btnRemover: "Remove",

      nenhumSelecionado: "No collaborators selected.",

      btnCancelar: "Cancel",
      btnCriarSala: "Create Room",
      btnSalvarAlteracoes: "Save Changes"
    }
  },
  es: {
    slogan: "Un lugar para compartir buenas ideas",
    modalCarregamento: "Espere por favor...",
    avancar: "Avanzar",
    voltar: "Volver",
    fechar: "Cerrar",
    cancelar: "Cancelar",
    carregando: "Espere por favor...",

    nenhumReaEncontrado: 'No se encontró ningún REA.',
    nenhumaComunidadeEncontrada: 'No se encontró ninguna comunidad.',

    home: {
      cardREA: 'Acceda, reutilice, cree, comparta',
      cardComunidades: 'Forme, reúna, participe, involúcrese',
      cardUsuarios: 'Conozca, encuentre, interactúe, motive'
    },

    navbar: {
      sobreNos: "Sobre nosotros",
      faleConosco: "Ayuda y Contacto",
      entrar: "Entrar",
      novoREA: "Nuevo Recurso",
      meusREA: "Mi área",
      tutorial: "Empezar aquí",
      config: "Ajustes",
      perfil: "Perfil",
      sair: "Salir",
      msgSaida: "¿Estás seguro de que quieres salir?",
      novaComunidade: "Nueva comunidad",
      minhasComunidades: "Mis comunidades",
      convites: "Invitaciones",
      fechar: "Cerrar",
      carregando: "Cargando...",
      carregandoConvites: "Llevando tus invitaciones...",
      nenhumConvitePendente: "No tienes invitaciones pendientes.",
      atualizarConvites: 'Actualizar',
      nenhumaComunidadeCriada: 'Aún no participas en ninguna comunidad.',
      inicio: "Comenzar",
      rea: "REA",
      membros: "Miembros",
      forum: "Foro",
      usuarios: "Colaboradores",
      comunidades: "Comunidades",
      rascunhoPendente: "Tienes un borrador pendiente. Termine de editar o guarde el borrador antes de registrar.",
      sairComunidade: 'Salir de la comunidad',
      msgSairComunidade: '¿Estás seguro de que deseas salir de la comunidad?',
      entrarOutraComunidade: 'Unirse a otra comunidad',
      msgEntrarOutraComunidade: 'Ya estás en una comunidad. ¿Deseas salir de ella y unirte a esta?',
    },

    aboutUs: {
      tituloObjetivo: "Objetivo",
      tituloSobreNos: "¿Quiénes somos?",
      tituloEducacaoAberta: "Acerca de la educación abierta",
      textoSobreNos: '<p>El Laboratorio de Computación Aplicada a la Educación y Tecnología Social Avanzada (CAEd) del <a href="https://www.icmc.usp.br" class="link-custom" target="_blank">Instituto de Ciencias Matemáticas y de Computación (ICMC)</a> de la <a href="https://saocarlos.usp.br/" class="link-custom" target="_blank">Universidad de São Paulo, campus São Carlos (USP São Carlos)</a>, reúne a investigadoras e investigadores dedicados al desarrollo de tecnologías y soluciones computacionales orientadas a contribuir al continuo perfeccionamiento y consolidación de las prácticas educativas.</p><p>El aquare!a, un repositorio dinámico de REA, fue concebido y desarrollado por Fernando Cesar Balbino, bajo la supervisión de Ellen Francine Barbosa. La versión actual contó con la participación de Diego Fernandes Lemos, responsable del diseño de la interfaz gráfica de la aplicación.</p><p>Nuestra expectativa es que aquare!a sea naturalmente percibido como una herramienta útil, productiva y facilitadora del ejercicio diario inherente a los desafíos educativos.</p>',
      textoObjetivo: '<p>aquare!a es una plataforma que promueve prácticas educativas abiertas, con énfasis en la creación, el intercambio y el uso de REA.</p><p>El proyecto fue concebido inicialmente para ofrecer a los docentes de Educación Básica una herramienta de comunicación, interacción y colaboración, con el objetivo de facilitar las prácticas de enseñanza (acceso a materiales didácticos para la preparación de clases, planificación y aplicación de actividades prácticas, ideas y enfoques diferenciados para la enseñanza, entre otros).</p><p>Además, la experiencia de uso de aquare!a también evidenció la posibilidad de conectar a educadores con estudiantes de licenciatura y viceversa, posibilitando un trabajo conjunto que integra el ejercicio de la profesión docente con la formación inicial, al mismo tiempo que la comunidad en general se beneficia con el acceso abierto a recursos educativos de calidad.</p><p>aquare!a puede ser utilizado libremente por cualquier persona interesada en producir, compartir y reutilizar conocimiento, ideas y experiencias educativas. ¡¡¡Regístrate y colabora!!!</p>',
      textoEducacaoAberta: '<p>El <a href="https://www.capetowndeclaration.org/read/" class="link-custom" target="_blank">movimiento de Educación Abierta</a> combina la experiencia humana de compartir buenas ideas con la cultura interactiva y colaborativa de Internet. Por eso, se fundamenta en la creencia de que todas las personas deben tener la libertad de usar, personalizar, mejorar y redistribuir recursos educativos sin restricciones, utilizando tecnologías que faciliten el intercambio abierto del conocimiento y el aprendizaje flexible y colaborativo.</p><p>En otras palabras, <a href="https://www.aberta.org.br/livrorea/livro/livroREA-1edicao-mai2012.pdf#page=19" class="link-custom" target="_blank">"el movimiento por una Educación Abierta es un intento de buscar alternativas sostenibles a algunas de las barreras evidentes en lo que respecta al derecho a una educación de calidad"</a>. Por lo tanto, las propuestas de la Educación Abierta no deben adoptarse con un carácter "salvacionista", en el sentido de ofrecer soluciones definitivas a los problemas y desafíos de la educación.</p><p>Desde una perspectiva realista, las acciones orientadas a la apertura de la educación, especialmente aquellas relacionadas con el uso de REA, pueden y deben coexistir con las prácticas educativas vigentes, de modo que la cultura abierta sea un camino viable y significativo para educadores y estudiantes.</p>',

      cargoFernando: 'Desarrollador Full Stack',
      profissaoFernando: 'Profesor en IFMS',
      cargoEllen: 'Supervisora del Proyecto',
      profissaoEllen: 'Profesora Asociada en ICMC-USP',
      cargoDiego: 'Designer Web Front End',
      profissaoDiego: 'Estudiante de Sistemas de Información en ICMC-USP',
    },

    contactUs: {
      frasePrincipal: "¿Necesitas ayuda con algo?",
      fraseSecundaria: "¡No dude en enviarnos un mensaje o consultar las preguntas frecuentes a continuación!",
      textoEmail: "¿Tiene alguna pregunta o sugerencia? Nuestro equipo está listo para ayudar. ¡Deja tu mensaje y responderemos lo antes posible!",
      mensagemSucesso: "¡Mensaje enviado con éxito!",
      mensagemErro: "Se produjo un error al enviar el correo electrónico. Inténtalo de nuevo más tarde.",
      nome: "Nombre *",
      nomeAviso: "Por favor ingrese su nombre.",
      email: "Correo electrónico *",
      emailAviso: "Ingrese un correo electrónico válido.",
      mensagem: "Mensaje *",
      mensagemAviso: "Ingrese su mensaje.",
      enviar: "Enviar",
      nomePlaceholder: "Ingrese su nombre",
      emailPlaceholder: "Ingrese su correo electrónico",
      mensagemPlaceholder: "Ingrese su mensaje",
      pergunta1: '¿Qué es un REA?',
      resposta1: "Un <a href='https://www.unesco.org/en/legal-affairs/recommendation-open-educational-resources-oer?hub=785' class='link-custom' target='_blank'>REA (Recurso Educativo Abierto)</a> es cualquier material educativo que puede ser usado, modificado y compartido libremente. Son creados con el objetivo de promover el acceso al conocimiento y a la educación de manera abierta y colaborativa.<br><br>Un REA puede ser una página explicativa sobre un tema, una imagen, una lista de ejercicios, un plan de clase, un relato de experiencia, un libro de texto completo, videos, un archivo de audio, un poema, una propuesta de actividad, entre otras posibilidades que cumplan un objetivo de enseñanza y/o aprendizaje.",

      pergunta2: '¿Qué es una licencia abierta Creative Commons?',
      resposta2: "Cualquier material educativo puede ser un REA siempre que esté licenciado con una licencia abierta. Las <a href='https://creativecommons.org/share-your-work/cclicenses/' target='_blank'>licencias abiertas Creative Commons (CC)</a> son las más conocidas y utilizadas en el movimiento REA.<br><br>Una licencia CC puede entenderse simplemente como un 'sello' que se coloca en algún lugar del material educativo. De esta forma, la persona que lo accede puede identificar cuáles son los derechos y deberes de uso de ese REA.<br><br>El único requisito común a todas las licencias CC es la obligación de dar crédito al autor de la obra, justamente para que se valore el trabajo intelectual.<br><br>Una licencia CC también determinará si el REA puede ser modificado, si puede ser usado con fines comerciales y cómo debe compartirse. Existen seis tipos de licencias CC, que varían según los permisos y restricciones. En aquare!a, se utilizan las cuatro licencias CC menos restrictivas.",

      pergunta3: '¿Qué significan las actividades 5R?',
      resposta3: "Las <a href='https://opencontent.org/blog/archives/3221' target='_blank'>actividades 5R</a> se refieren a las libertades de uso de un REA, que son:<ul><li><b>Retain</b>: el derecho de <b>guardar</b> una copia del material.</li><li><b>Reuse</b>: el derecho de <b>usar</b> el material en diferentes contextos y según sea necesario.</li><li><b>Revise</b>: el derecho de <b>adaptar</b> el material, es decir, modificarlo para atender necesidades específicas.</li><li><b>Remix</b>: el derecho de <b>combinar</b> diferentes materiales para crear uno nuevo, según sea necesario.</li><li><b>Redistribute</b>: el derecho de <b>redistribuir</b> el material, es decir, compartir copias del original o de las nuevas versiones.</li></ul>Cada licencia abierta Creative Commons determinará cuáles de estas libertades se conceden. Una cosa es segura: siempre tendrás el derecho de guardar, usar y redistribuir un REA. Solo no olvides dar crédito al autor.",

      pergunta4: '¿Para qué sirve aquare!a?',
      resposta4: "Aquare!a es una plataforma que promueve prácticas educativas abiertas, con enfoque en la creación, el intercambio y el uso de REA para todos los niveles de la educación básica. Sirve para conectar educadores, estudiantes y la comunidad en general, promoviendo el acceso al conocimiento de manera colaborativa y abierta.<br><br>Existen tres posibilidades para crear y compartir un REA en aquare!a:<ul><li><b>Crear contenido:</b> consiste en la creación de un REA utilizando un editor disponible en aquare!a. Además de texto, el REA puede contener imágenes, videos y enlaces a otros recursos disponibles en internet. Una vez listo, el REA puede ser accedido como una página web, que puede imprimirse fácilmente, descargarse en PDF, compartirse en redes sociales, modificarse y redistribuirse.</li><li><b>Crear una ruta de aprendizaje:</b> consiste en la creación de un REA que reúne otros REA, formando una secuencia didáctica para la enseñanza y el aprendizaje gradual de un tema. Una ruta de aprendizaje también puede servir para reunir REA que no necesitan ser considerados en secuencia, pero que están relacionados, como un texto explicativo, una lista de ejercicios y un plan de clase.</li><li><b>Subir un archivo:</b> permite compartir cualquier tipo de archivo (un documento PDF, un conjunto de diapositivas, una hoja de cálculo, etc.) o un enlace a un recurso externo (por ejemplo, un sitio web o un libro abierto).</li></ul>En cualquiera de estas opciones, puedes crear, compartir y reutilizar diversos tipos de materiales educativos. Además, aquare!a ofrece herramientas para la creación de comunidades, donde es posible debatir, compartir experiencias y colaborar en la producción de nuevos REA.",

      pergunta5: '¿Para qué crear una comunidad en aquare!a?',
      resposta5: "Crear una comunidad en aquare!a significa organizar un espacio en el que un grupo de personas pueda conectarse en torno a intereses y objetivos comunes. Esto puede facilitar el intercambio de ideas y reunir esfuerzos para que, mediante la colaboración, cada participante se beneficie en sus actividades educativas.<br><br>Los profesores de una misma escuela pueden, por ejemplo, crear una comunidad para compartir REA sobre temas transversales que abarquen distintas asignaturas. O bien, profesores de matemáticas de una red municipal pueden crear una comunidad para elaborar un cuaderno didáctico con actividades prácticas basadas en diferentes enfoques y experiencias de enseñanza.<br><br>Por lo tanto, las comunidades pueden crearse en aquare!a para debatir temas de interés, compartir materiales educativos, intercambiar experiencias y colaborar en la producción de nuevos REA.",

      pergunta6: '¿Qué son las prácticas educativas abiertas?',
      resposta6: "La creación de REA en aquare!a incluye la asignación de licencias abiertas que aseguran las libertades 5R. Profesores, estudiantes y la comunidad en general pueden crear, compartir, modificar y redistribuir materiales educativos de manera práctica e intuitiva.<br><br>La interacción entre los colaboradores registrados en aquare!a puede darse mediante comunicación directa (chat) o en espacios organizados para discusión e intercambio de experiencias (comunidades).<br><br>Por eso, aquare!a es un repositorio dinámico de REA, ya que promueve <a href='https://www.irrodl.org/index.php/irrodl/article/view/3096' target='_blank'>prácticas educativas abiertas</a>. Esto significa que aquare!a funciona como una tecnología participativa y de red social para prácticas colaborativas que incluyen la creación, uso y reutilización de REA, así como la interacción, el aprendizaje entre pares, la construcción de conocimiento y el empoderamiento de educadores y aprendices.",
    },

    login: {
      titulo: "Educación abierta para todos. ¡Comienza tu viaje ahora!",
      email: "Ingrese su correo electrónico",
      senha: "Ingrese su contraseña",
      entrar: "Entrar",
      alertEmailSenha: "Correo electrónico o contraseña no registrada o no activada.",
      alertSemEmail: "Ingrese el correo electrónico para redefinir la contraseña.",
      alertEmail: "Correo electrónico no registrado o no activado.",
      alertSenhaSucesso: "Se envió una nueva contraseña a su correo electrónico.",
      alertSenhaErro: "Lamentablemente, no fue posible redefinir su contraseña. Póngase en contacto con nosotros para que podamos ayudar.",
      lembreteSenha: "¿Olvidó la contraseña?",
      lembreteCadastro: "¿Aún no tiene registro?",
      clique: "¡Haga clic aquí!",
      criar: "¡Crea tu cuenta!"
    },

    perfil: {
      publicados: "Mis REAs publicados",
      favoritos: "Mis favoritos",
      rascunhos: "Mis borradores"
    },

    formsColaborador: {
      colaborador: "Colaborador",
      nome: "Nombre *",
      placeholderNome: "Ingrese su nombre",
      nomeAlert: "Por favor ingrese su nombre.",
      email: "Correo electrónico *",
      placeholderEmail: "seuemail{'@'}exemplo.com",
      emailAlert: "Ingrese un correo electrónico válido.",
      voce: "Acerca de ti *",
      placeholderVoce: "Escriba sobre ti",
      voceAlert: "Descríbete para que otras personas puedan conocerla.",
      ie: "Nombre de la institución educativa (es decir) * *",
      placeholderIe: "Ingrese el nombre de I.E.",
      ieAlert: "Ingrese el nombre de, es decir, donde trabaja o estudia.",
      siglaIE: "Acrónimo de I.E. *",
      placeholderSiglaIe: "Ingrese el acrónimo",
      siglaIEAlert: "Ingrese el acrónimo del nombre de, es decir, donde trabaja o estudia.",
      rede: "Red de enseñanza *",
      municipal: "Municipal",
      estadual: "Estado",
      federal: "Federal",
      privada: "Privado",
      redeAlert: "Ingrese el I.E.",
      cidade: "Ciudad *",
      placeholderCidade: "Ingrese el nombre de la ciudad de I.E.",
      cidadeAlert: "Ingrese la ciudad de la ubicación de I.E.",
      uf: "UF de I.E. *",
      ufAlert: "Ingrese la ciudad informada UF.",
      funcao: "Función *",
      professor: "Maestro",
      coordenador: "Coordinador",
      diretor: "Director",
      estudante: "Alumno",
      outra: "Otro",
      funcaoAlert: "Ingrese su función en I.E.",
      senha: "Contraseña *",
      placeholderSenha: "Ingrese su contraseña",
      senhaAlert: "Ingrese la contraseña para acceder al sistema.",
      confSenha: "Confirmación de contraseña *",
      confSenhaAlert: "Confirme la contraseña para acceder al sistema.",
      confSenhaAlertDiferente: "Las contraseñas no marcan. Por favor, escribalos de nuevo.",
      interesse: "Área (s) de actuación/interés *",
      interesseAlert: "Indique al menos un área de especialización/interés.",
      salvar: "Salvar",
      cancelar: "Cancelar",
      dadosAtualizados: "¡Sus datos han sido actualizados!",
      atualizacaoPerfil: "Actualización de perfil",
      modalConfirmCancelEdit: {
        titulo: 'Cancelar edición',
        mensagem: '¿Está seguro de que desea salir? Todos los cambios se perderán.'
      },
      sucessoCadastroTitulo: "¡Bienvenida/o a aquare!a!",
      sucessoCadastroMensagem: "Por favor, accede a tu correo electrónico para activar tu registro. ¡Gracias!",
      aviso: "Aviso",
      emailDuplicado: "El correo electrónico informado ya está registrado.",
    },

    formsREA: {
      newResourceConteudo: 'Nuevo recurso / Contenido',
      newResourceTrilha: 'Nuevo recurso / Ruta de aprendizaje',
      newResourceArquivo: 'Nuevo recurso / Archivo',
      titulo: "Título *",
      placeholderTitulo: "Ingrese el título",
      tituloAlert: "Ingrese el título del área.",
      descricao: "Descripción *",
      placeholderDescricao: "Ingrese la descripción",
      descricaoAlert: "Describe el área.",
      autores: "Autor (s) *",
      autoresAlert: "Informe al menos a un autor.",
      tipoConteudo: "Tipo de contenido *",
      tipoConteudoAlert: "Ingrese el tipo de área.",
      optionDocumentoHTML: "Documento HTML",
      optionTrilhaAprendizagem: "Rastro de aprendizaje",
      optionVideo: "Video",
      optionAudio: "Archivo de audio",
      optionPDF: "Archivo pdf",
      optionTexto: "Archivo de texto",
      optionSoftware: "Software",
      optionOutro: "Otro",
      area: "Área de conocimiento *",
      areaAlert: "Ingrese el área de conocimiento al que pertenece el área.",
      optionAreaEuOutroNos: "El yo, el otro y nosotros",
      optionAreaCorpoGestos: "Cuerpo, gestos y movimientos",
      optionAreaTracosSons: "Rastros, sonidos, colores y formas",
      optionAreaEscutaFala: "Escuchar, discurso, pensamiento e imaginación",
      optionAreaEspacosTempos: "Espacios, tiempos, cantidades, relaciones y transformaciones",
      optionAreaEF_Linguagens: "Idiomas",
      optionAreaEF_Matematica: "Matemáticas",
      optionAreaEF_CienciasNatureza: "Ciencias Naturales",
      optionAreaEF_CienciasHumanas: "Humanidades",
      optionAreaEF_EnsinoReligioso: "Enseñanza religiosa",
      optionAreaEM_Linguagens: "Idiomas y sus tecnologías",
      optionAreaEM_Matematica: "Matemáticas y sus tecnologías",
      optionAreaEM_CienciasNatureza: "Ciencias de la naturaleza y sus tecnologías",
      optionAreaEM_CienciasHumanasSociais: "Ciencias humanas y sociales aplicadas",
      optionAreaMultidisciplinar: "Multidisciplinario",
      idioma: "Idioma *",
      optionIdiomaPortugues: "Portugués",
      optionIdiomaIngles: "Inglés",
      optionIdiomaEspanhol: "Español",
      optionIdiomaOutro: "Otro",
      idiomaAlert: "Informe el idioma do REA.",
      palavrasChave: "Palabras clave *",
      placeholderPalavrasChave: "Ingrese las palabras clave",
      palavrasChaveAlert: "Ingrese al menos una palabra clave.",
      licencaCC: "Tipo de licencia Creative Commons *",
      permitirUsoComercialPergunta: "¿Permitir usos comerciales de su trabajo?",
      sim: "Sí",
      nao: "No",
      usoComercialAlert: "Decide el uso comercial del área.",
      permitirModificacoesPergunta: "¿Permitir modificaciones de su trabajo?",
      simDesdeQueCompartilhemIgual: "Sí, mientras otros compartan lo mismo",
      modificacoesAlert: "Por favor, decida las modificações do área.",
      descCCBySa: "Esta licencia permite que outras pessoas remezcle, adaptem e usen su área, incluida comercialmente, siempre que sea citado adecuadamente como autor de la versión original y el trabajo derivado tiene licencia en los mismos términos. Por lo tanto, todo el trabajo derivado de su versión original también permitirá el uso comercial.",
      descCCBy: "Esta licencia permite que outras pessoas distribuyan, remix, adapten e usen su área, incluida comercialmente, siempre que sea citado adecuadamente como autor de la versión original. Esta es la licencia más flexible y de acuerdo con la cultura libre.",
      descCCByNcSa: "Esta licencia permite que outras pessoas remezcle, se adapten e usen sus propósitos no comerciales, siempre y cuando sea citado adecuadamente como el autor de la versión original y el trabajo derivado tiene licencia exactamente bajo los mismos términos.",
      descCCByNc: "Esta licencia permite que outras pessoas remezcle, se adaptem e usen sus extremos no comerciales, siempre que se cita correctamente como el autor de la versión original. Los trabajos derivados no necesitan tener licencia en los mismos términos, pero no pueden permitir el uso comercial.",
      buttonCancelar: "Cancelar",
      buttonAvancar: "Avanzar",
      confirmCancelar: "¿Estás seguro de que quieres cancelar? Todo el contenido se perderá."
    },
    select: {
      conteudo: "Crear contenido",
      trilha: "Crear <br> ruta de aprendizaje",
      arquivo: "Subir archivo"
    },
    search: {
      buscarREAs: "Buscar",
      buscarComunidades: "Buscar comunidades",
      buscarUsuarios: "Buscar colaboradores",
      nenhumResultado: "No se encontraron resultados",
      carregandoDados: "Cargando datos...",
      erroCarregarREAs: "Error al buscar REA",
      erroCarregarComunidades: "Error al buscar comunidades",
      erroCarregarUsuarios: "Error al buscar colaboradores",
      paginaAlterada: "Página cambiada para",
      abaAlterada: "Aleta alterada",
      buscaExecutada: "Buscar",
      totalResultados: "Resultados totales",
      página: "Página"
    },
    tutorial: {
      tituloComece: "Empezar aquí",
      tituloPassos: "Pinitos",
      tituloGuia: "Guía completa",
      textoComece: "¡Bienvenido a la acuarela! Este es su punto de partida para crear y compartir recursos educativos abiertos (REA). Aquí aprenderá a navegar por la plataforma y crear su primer contenido educativo.",
      textoPassos: "Siga estos simples pasos para comenzar: 1) Crear su cuenta o iniciar sesión; 2) Explore el área existente a inspirar; 3) Haga clic en \"Nueva función\" para crear su primer contenido; 4) Complete la información básica; 5) Agregue su contenido; 6) ¡Publicar y compartir!",
      textoGuia: "Para una guía más detallada, explore nuestra documentación completa. Encontrará videos tutoriales, ejemplos prácticos y consejos para crear contenido educativo de calidad siguiendo los principios de los 5 R de educación abierta."
    },
    profile: {
      alterarFotoPerfil: "Cambiar foto de perfil",
      convidarParaComunidade: "Invitar",
      editarPerfil: "Editar perfil",
      sobreMim: "Acerca de mí",
      comunidadesQueParticipo: "Comunidades en las que participo",
      usuarioNaoPublicouREA: "Este colaborador aún no ha publicado ninguna REA.",
      usuarioNaoFavoritouREA: "Este colaborador aún no ha favorecido a ninguna área.",
      usuarioNaoParteComunidade: "Este colaborador aún no es parte de ninguna comunidad.",
      voceSemRascunhos: "Todavía no tienes borradores guardados.",
      modalFoto: {
        titulo: "Cambiar foto de perfil",
        preview: "Vista previa de la foto",
        selecioneNovaFoto: "Seleccione una nueva foto:",
        formatosAceitos: "Formatos aceptados: JPG, PNG, GIF. Tamaño máximo: 5 MB.",
        cancelar: "Cancelar",
        salvandoFoto: "Salvando...",
        salvarFoto: "Guardar foto",
        erroApenasImagens: "Seleccione solo archivos de imagen.",
        erroTamanhoMaximo: "El archivo debe tener un máximo de 5 MB.",
        erroSelecioneFoto: "Seleccione una foto.",
        sucessoFotoAtualizada: "¡Foto de perfil actualizada con éxito!",
        erroArquivoGrande: "Archivo muy grande. Máximo permitido: 5 MB.",
        erroFormatoNaoSuportado: "Formato de archivo no es compatible.",
        erroUploadFoto: "Error al subir la foto. Intentar otra vez."
      },
      modalConvite: {
        titulo: "para una comunidad",
        carregandoComunidades: "Llevando sus comunidades...",
        voceSemComunidades: "Todavía no eres parte de ninguna comunidad.",
        precisaSerMembro: "Para invitar a otros colaboradores, debe ser miembro de una comunidad.",
        selecioneComunidade: "Seleccione una comunidad para enviar la invitación:",
        nomeComunidade: "Nombre de la comunidad",
        membros: "Miembros",
        acao: "Acción",
        convidar: "Invitar",
        cancelar: "Cancelar",
        fechar: "Cerrar",
        convidante: 'Invitado por',
        sucessoConviteEnviado: "Invitación enviada con éxito a",
        erroUsuarioJaConvidado: "Este colaborador ya ha sido invitado o ya es parte de esta comunidad.",
        erroUsuarioNaoEncontrado: "Colaborador o comunidad no encontrado.",
        erroEnviarConvite: "Error enviando una invitación. Intentar otra vez.",
        erroCarregarComunidades: "Error al llevar a sus comunidades. Intentar otra vez."
      }
    },

    notFound: {
      titulo: "Página no encontrada... 😢",
      descricao: "La página que está buscando no fue encontrada.",
      paginaInicial: "hogar",
      ou: "o",
      mandeMensagem: "¡Envía un mensaje!"
    },
    draftPreview: {
      tituloNaoDisponivel: "Título no disponible",
      descricaoNaoDisponivel: "Descripción No disponible",
      palavrasChave: "Palabras clave: ",
      autores: "Autor (s): ",
      tipoConteudo: "Tipo de contenido: ",
      areaConhecimento: "Área de conocimiento: ",
      idioma: "Idioma: ",
      dataPublicacao: "Fecha de publicación: ",
      visualizacoes: "Vistas: ",
      adaptacoes: "Adaptaciones: ",
      remixes: "Remixes: ",
      licenca: "Licencia: ",
      guardar: "Favorito",
      adaptar: "Adaptar",
      baixar: "Bajar",
      compartilhar: "Compartir",
      avaliar: "Evaluar",
      adaptacoesBtn: "Adaptaciones",
      conteudoNaoDisponivel: "No contenido disponible",
      trilhaAprendizado: "Ruta de aprendizaje:",
      reaDisponivelInternet: "Este REA está disponible en el enlace de abajo. Haz clic para acceder.",
      linkRea: "Enlace:",
      reaDisponivelDownload: "Este REA solo está disponible para descargar. Haga clic a continuación para descargar.",
      nomeArquivo: "Archivo:",
      nomeArquivoNaoDisponivel: "Nombre del archivo No disponible",
      nenhumArquivoConfigurado: "No hay archivo o URL configurado.",
      confirmacaoPublicacao: "Después de ser publicado, el REA aún podrá ser editado o eliminado (siempre que no haya sido reutilizado por otras personas).\n¿Desea publicarlo ahora?",
      nao: "No",
      sim: "Sí",
      aguarde: "Espere por favor...",
      voltar: "Volver",
      excluir: "Borrar",
      continuarEdicao: "Eliminar borrador",
      continuar: 'Continuar edición',
      confirmarExclusao: "¿Estás seguro de que quieres eliminar este borrador? Esta acción no se puede deshacer.",
      dataIndisponivel: "Fecha no disponible"
    },
    cardView: {
      selecioneEstrela: "Por favor, selecciona una estrella para calificar.",
      palavrasChave: "Palabras clave: ",
      autores: "Autor (s): ",
      publicadoPor: "Publicado por: ",
      tipoConteudo: "Tipo de contenido: ",
      areaConhecimento: "Área de conocimiento: ",
      idioma: "Idioma: ",
      dataPublicacao: "Fecha de publicación: ",
      visualizacoes: "Vistas: ",
      avaliacoes: "Valoraciones: ",
      adaptacoes: "Adaptaciones: ",
      remixes: "Remixes: ",
      licenca: "Licencia: ",
      guardar: "Favorito",
      adaptar: "Adaptar",
      imprimir: "Imprimir",
      compartilhar: "Compartir",
      avaliar: "Evaluar",
      adaptacoesBtn: "Adaptaciones",
      adicionarFavoritos: "Agregar a mis favoritos",
      trilhaAprendizado: "Ruta de aprendizaje:",
      reaDisponivelInternet: "Este REA está disponible en el enlace de abajo. Haz clic para acceder.",
      linkRea: "Enlace:",
      reaDisponivelDownload: "Este REA solo está disponible para descargar. Haga clic a continuación para descargar.",
      nomeArquivo: "Archivo:",
      adaptacoesDesteRea: "Adaptaciones de esta área",
      aguarde: "Espere por favor...",
      oQueVoceAchou: "¿Qué pensaste de este REA?",
      escrevaComentario: "Escribe tu comentario aquí...",
      cancelar: "Cancelar",
      enviar: "Enviar",
      facaLoginAvaliar: "Inicie sesión para evaluar este REA",
      entreContaAvaliar: "Ingrese su cuenta para dejar una evaluación y ayudar a la comunidad.",
      reaAdicionadoFavoritos: "¡REA agregada a tus favoritos!",
      licencaNaoEspecificada: "Licencia no especificada",
      licencaTexto: "Licencia",
      licencaDescricao: "Esta área tiene licencia bajo",
      licencaInfoVisitar: "Para obtener más información sobre esta licencia, visite:",
      confiraRecurso: "¡Hola! Echa un vistazo a este recurso educativo abierto:",
      // Nuevas traducciones para comunidades
      adicionarAComunidade: 'Agregar REA a una Comunidad',
      carregandoComunidades: 'Cargando sus comunidades...',
      voceSemComunidades: 'Todavía no eres parte de ninguna comunidad.',
      precisaSerMembro: 'Para agregar REAs, necesitas ser miembro de una comunidad.',
      selecioneComunidade: 'Seleccione una comunidad para agregar este REA:',
      adicionar: 'Agregar',
      reaAdicionadoComSucesso: 'REA agregado exitosamente a la comunidad',
      reaJaAssociado: 'Este REA ya está asociado con esta comunidad.',
      comunidadeOuREANaoEncontrado: 'Comunidad o REA no encontrados.',
      erroAdicionarREA: 'Error al agregar REA a la comunidad. Inténtalo de nuevo.',
      selecionaEstrela: 'Por favor, seleccione una estrella para evaluar.',
      // Edição e exclusão de REA
      editar: "Editar",
      excluir: "Eliminar",
      confirmarExclusaoTitulo: "Eliminar REA",
      confirmarExclusaoMensagem: "¿Está seguro de que desea eliminar este REA? Esta acción no se puede deshacer.",
      reaExcluidoSucesso: "¡REA eliminado con éxito!",
      erroExcluirRea: "No fue posible eliminar el REA.",
      editarRea: "Editar REA",
      quotaExcedidaAdaptacao: 'No fue posible adaptar este REA porque el tamaño del contenido supera el límite de almacenamiento del navegador.',
      quotaExcedidaEdicao: 'No fue posible editar este REA porque el contenido supera el límite de almacenamiento local del navegador.'
    },
    uploadREA: {
      titulo: "NUEVO SUPERACIÓN DE ARCHIVO",
      cliqueSelecionarArquivo: "Haga clic para seleccionar un archivo o arrastre y suelte aquí...",
      campoDesabilitadoUrl: "Elimina la URL para habilitar esta área y subir un archivo.",
      ou: "o",
      placeholderLink: "Ingrese el enlace al archivo aquí",
      campoDesabilitadoArquivo: "Elimina el archivo para habilitar esta área e insertar una URL.",
      erroArquivoOuLink: "Cargue un archivo o ingrese el enlace en el que se puede acceder.",
      voltar: "Volver",
      cancelar: "Cancelar",
      avancar: "Avanzar",
      baixandoArquivo: "Descarga de archivo...",
      tamanhoMaximo: "El tamaño máximo permitido para el archivo es de 20 MB.",
      confirmarCancelamento: "¿De verdad quieres cancelar?",
      erroArquivoInvalido: "Error: archivo no válido. Seleccione el archivo nuevamente.",
      removerArquivo: "Eliminar",
    },
    trilhaAprendizagem: {
      adicionePeloMenosUmREA: "Agregue al menos un área al ruta antes de avanzar.",
      reaJaAdicionado: "Esta área ya se ha agregado al ruta. No es posible agregar reas duplicado.",
      reasDuplicadosDetectados: "Se detectaron áreas duplicadas en la ruta. Retire los duplicados antes de continuar.",
      erroAdicionarREA: "Error a agregar el área al ruta. Intentar otra vez.",
      confirmarCancelamento: "¿Estás seguro de que quieres cancelar? Todo el contenido se perderá.",
      licencasIncompativeis: 'Se encontraron REA con licencias incompatibles con la licencia elegida para esta ruta de aprendizaje ({licenca}). Solo se pueden añadir REA con las siguientes licencias: {licencas}.',
      licencasCompativeis: 'Has asignado la licencia {licenca} a la ruta de aprendizaje. Solo se mostrarán los REA con licencias compatibles ({licencas}) en los resultados de búsqueda.',
      toastCardAdicionado: "¡REA añadido a la ruta de aprendizaje!",
    },
    tinyEditor: {
      voltar: "Volver",
      cancelar: "Confirmar cancelación",
      avancar: "Avanzar",
      aviso: "Aviso",
      editorNaoPodeEstarVazio: "El editor de texto no puede estar vacío.",
      confirmarCancelamento: "¿Estás seguro de que quieres cancelar? Todo el contenido se perderá.",
      pecaAjudaIA: "¡Pide ayuda a una IA!",
      digitePerguntaIA: "Escribe tu pregunta para la IA aquí...",
      gerarTexto: "Generar texto",
    },
    postPreview: {
      confirmacaoPublicacaoTitulo: 'Confirmación de publicación',
      palavrasChave: "Palabras clave: ",
      definirImagemCapa: "Definir imagen de portada",
      autores: "Autor (s): ",
      autoresOriginaisRemovidos: "Autores originales eliminados: ",
      deveIncluirAutoresOriginais: "Debe incluir todos los autores originales de esta adaptación para poder guardar o publicar.",
      tipoConteudo: "Tipo de contenido: ",
      areaConhecimento: "Área de conocimiento: ",
      idioma: "Idioma: ",
      dataPublicacao: "Fecha de publicación: ",
      visualizacoes: "Vistas: ",
      adaptacoes: "Adaptaciones: ",
      remixes: "Remixes: ",
      licenca: "Licencia: ",
      licencaOriginalNaoAlterada: "Licencia original (no se puede cambiar en adaptaciones)",
      guardar: "Favorito",
      adaptar: "Adaptar",
      baixar: "Bajar",
      compartilhar: "Compartir",
      avaliar: "Evaluar",
      adaptacoesBtn: "Adaptaciones",
      trilhaAprendizado: "Ruta de aprendizaje:",
      reaDisponivelInternet: "Este REA está disponible en el enlace de abajo. Haz clic para acceder.",
      linkRea: "Enlace:",
      reaDisponivelDownload: "Este REA solo está disponible para descargar. Haga clic a continuación para descargar.",
      nomeArquivo: "Archivo:",
      arquivoSelecionado: "Archivo seleccionado",
      nenhumArquivoConfigurado: "No hay archivo o URL configurado.",
      confirmacaoPublicacao: "Después de ser publicado, el REA aún podrá ser editado o eliminado (siempre que no haya sido reutilizado por otras personas).\n¿Desea publicarlo ahora?",
      nao: "No",
      sim: "Sí",
      aguarde: "Espere por favor...",
      voltar: "Volver",
      cancelar: "Cancelar",
      salvarRascunho: "Guardar borrador",
      publicar: "Publicar",
      confirmarCancelamento: "¿Estás seguro de que quieres cancelar? Todo el contenido se perderá.",
      naoSalvarRascunhoAutores: "No es posible salvar como borrador. Debe incluir a todos los autores originales de esta adaptación antes de salvar.",
      naoPublicarAutores: "No es posible publicar. Debe incluir todos los autores originais desta adaptação antes de publicar.",
      rascunhoAtualizadoSucesso: "¡Borrador actualizado exitoso!",
      rascunhoSalvoSucesso: "¡Garras guardadas con éxito!",
      reaSalvoSucesso: "¡Felicidades! Has publicado un REA y acabas de contribuir a una educación de calidad.",
      erroArquivoInvalido: "Error: no se encontró un archivo o URL válida. Seleccione un archivo o ingrese una URL.",
      rascunhoDesabilitadoPublicado: "No es posible guardar un borrador de un REA ya publicado."
    },
    formsComunidade: {
      novaComunidade: "Nueva comunidad",
      campoImagem: "Campo de imagen",
      nome: "Nombre *",
      placeholderNome: "Ingrese el nombre de la comunidad...",
      nomeAlert: "Ingrese el nombre de la comunidad.",
      descricao: "Descripción *",
      descricaoAlert: "Ingrese la descripción de la comunidad.",
      criarComunidade: "Crear comunidad",
      comunidadeCriadaSucesso: "Comunidad creada con éxito!",
      removerCapa: "Eliminar portada",
    },
    formsViewREA: {
      comunidade: "Comunidad",
      carregandoNomeComunidade: "Llevando el nombre de la comunidad...",
      removerAssociacaoComunidade: "Eliminar asociación con la comunidad",
      reaAdicionadoComunidade: "Esta área se agregará a la comunidad que está navegando. Puede eliminar esta asociación haciendo clic en \"×\".",
      licencaAdaptacao: "Licencia (adaptación)",
      esteEAdaptacao: "Esta es una adaptación de un área existente.",
      licencaOriginalPreservada: "La licencia original se conservará automáticamente. No es posible cambiar la licencia en adaptaciones.",
      licencaOriginalRea: "Licencia original del área que se está adaptando.",
      licencaSeraMantida: "La licencia original requiere que la adaptación sea licenciada bajo los mismos términos.",
      licencaPodeSerAlteradaLivremente: 'La licencia original es CC BY, por lo tanto puedes elegir cualquier otra licencia para esta adaptación.',
      licencaDeveManterNCComOpcaoSA: 'La licencia original es CC BY-NC. Tu adaptación debe mantener NC, pero puedes incluir SA si lo deseas.',
      nomeComMaisDe50Caracteres: "Nombre con más de 50 caracteres; Dar 2 clics sobre el nombre para editar",
      nomeJaIncluido: "Nombre ya incluido",
      tagComMaisDe50Caracteres: "Etiqueta con más de 50 caracteres; Dar 2 clics sobre la etiqueta para editar",
      tagJaIncluido: "Etiqueta ya incluida",
      desejaRemoverAssociacaoComunidade: "¿Quiere eliminar la asociación de esta área con la comunidad?"
    },
    usuarioDisplay: {
      nenhumUsuarioEncontrado: "No se ha encontrado ningún colaborador.",
      facaPesquisaEncontrarUsuarios: "Haga una búsqueda para encontrar usuarios en la plataforma."
    },
    modalCardSearch: {
      adicionar: "Agregar REA"
    },
    searchBar: {
      placeholder: "Escriba palabras individuales o expresiones entre comillas",
      aplicarFiltros: "Aplicar filtros",
      limparFiltros: "Limpiar filtros",
      licencas: "Licencias:",
      areas: "Áreas:",
      funcoes: "Funciones:",
      interesses: "Intereses:",
      licencaBy: "BY",
      licencaBySa: "BY-SA",
      licencaByNc: "BY-NC",
      licencaByNcSa: "BY-NC-SA",
      educacaoInfantil: 'Educación Inicial',
      ensinoFundamental: 'Educación Primaria',
      ensinoMedio: 'Educación Secundaria',
      areaEiEuOutroNos: "El yo, el otro y nosotros",
      areaEiCorpoGestos: "Cuerpo, gestos y movimientos",
      areaEiTracosSons: "Rastros, sonidos, colores y formas",
      areaEiEscutaFala: "Escuchar, discurso, pensamiento e imaginación",
      areaEiEspacosTempos: "Espacios, tiempos, cantidades, relaciones y transformaciones",
      areaEfLinguagens: "Idiomas",
      areaEfMatematica: "Matemáticas",
      areaEfCienciasNatureza: "Ciencias Naturales",
      areaEfCienciasHumanas: "Humanidades",
      areaEfEnsinoReligioso: "Enseñanza religiosa",
      areaEmLinguagens: "Idiomas y sus tecnologías",
      areaEmMatematica: "Matemáticas y sus tecnologías",
      areaEmCienciasNatureza: "Ciencias de la naturaleza y sus tecnologías",
      areaEmCienciasHumanas: "Ciencias humanas y sociales aplicadas",
      areaMultidisciplinar: "Multidisciplinario",
      funcaoProfessor: "Maestro",
      funcaoCoordenador: "Coordinador",
      funcaoEstudante: "Alumno",
      funcaoDiretor: "Director",
      funcaoOutro: 'Outro',
    },
    reaDisplayComunidade: {
      buscarREAsNestaComunidade: "Buscar áreas en esta comunidad...",
      nenhumREAEncontrado: "No se ha encontrado ningún REA.",
      tenteOutraVez: "¡Intentar otra vez!",
      comunidadeSemREAs: "Esta comunidad aún no tiene áreas.",
      escopo: "Alcance de búsqueda:",
      apenasREAsComunidade: "Solo REA de esta comunidad",
      todosREAs: "Todos los REA de la plataforma"
    },
    membroDisplay: {
      apenasMembrosComunidade: 'Solo miembros de esta comunidad',
      todosMembros: 'Todos los miembros de la plataforma',
      pesquisarMembroPeloNome: "Búsqueda de miembros por nombre...",
      pesquisar: "Buscar",
      aplicarFiltros: "Aplicar filtros",
      limparFiltros: "Limpiar filtros",
      funcoes: "Funciones:",
      interesses: "Intereses:",
      professor: "Maestro",
      coordenador: "Coordinador",
      estudante: "Alumno",
      diretor: "Director",
      nenhumMembroEncontrado: "Ningún miembro encontrado con los criterios de búsqueda aplicados.",
      comunidadeSemMembros: "Esta comunidad aún no tiene miembros."
    },
    comunidadeCard: {
      capaComunidade: "Cubierta comunitaria",
      criadaEm: "Creado en",
      membros: "miembros",
      membro: "miembro"
    },
    cards: {
      autor: "Autor: ",
      data: "Fecha: ",
      licenca: "Licencia: ",
      visualizacoes: "Vistas: ",
      imagemAleatoria: "Aleatorio"
    },
    trilhaSearchHeader: {
      resultadoPesquisa: "Resultados de la búsqueda",
      buscaAvancada: "Búsqueda avanzada",
      carregandoREAsCompativeis: "Llevando reas compatible...",
      resultadosEncontrados: "resultado (s) encontrado para",
      resultadosEncontradosTotal: "resultados encontrados"
    },
    trilhaSearchBar: {
      procurarREA: "Buscar un REA...",
      licencaFixa: "Licencia",
      licencaBaseDraft: "Basado en la configuración de su ruta"
    },
    contentCardREATrilhadeAprendizagem: {
      palavrasChave: "Palabras clave: ",
      capaREA: "Tapa de referencia",
      autores: "Autor (s): ",
      tipoConteudo: "Tipo de contenido: ",
      areaConhecimento: "Área de conocimiento: ",
      idioma: "Idioma: ",
      dataPublicacao: "Fecha de publicación: ",
      visualizacoes: "Vistas: ",
      adaptacoes: "Adaptaciones: ",
      remixes: "Remixes: ",
      licenca: "Licencia: ",
      trilhaAprendizado: "Ruta de aprendizaje: ",
      reaDisponivelInternet: "Este REA está disponible en el enlace de abajo. Haz clic para acceder.",
      linkREA: "Enlace:",
      reaDisponivelDownload: "Este REA solo está disponible para descargar. Haga clic a continuación para descargar.",
      nomeArquivo: "Archivo:"
    },
    cardsTrilhadeAprendizagem: {
      capaREA: "Tapa de referencia",
      autor: "Autor: ",
      data: "Fecha: ",
      visualizacoes: "Vistas:"
    },
    cardsDisplayTrilhadeAprendizagem: {
      nenhumREACompativel: "Ninguna área es compatible con las licencias seleccionadas.",
      nenhumREAEncontrado: "No se ha encontrado ningún área para la búsqueda de",
      tenteOutraVez: "¡Intentar otra vez!"
    },
    searchHeader: {
      tituloREA: 'Buscar REA',
      tituloComunidade: 'Buscar comunidades',
      tituloUsuario: 'Buscar colaboradores',
      facaPesquisa: "¡Haz una búsqueda!",
      resultadosEncontrados: "resultado (s) encontrado para",
      resultadosEncontradosTotal: "resultados encontrados",
      filtrosAtivos: "filtros",
      filtroLicenca: "licencias",
      filtroArea: "áreas",
      filtroFuncao: "funciones",
      filtroInteresse: "intereses"
    },
    comunidade: {
      nome: "Nombre",
      status: "Estado",
      criacao: "Creación",
      acoes: "Acciones",
      ativa: "Activo",
      inativa: "Inactivo",
      desativar: "Desactivar",
      reativar: "Reactivar",
      bemVindo: "¡Bienvenido a la comunidad!",
      descricaoBemVindo: "Explore los recursos y conéctese con otros miembros.",
      alterarImagemCapa: "Cambiar imagen de portada",
      modalCapa: {
        titulo: "Cambiar la portada de la comunidad",
        cancelar: "Cancelar",
        confirmar: "Confirmar"
      },
      modalEdicao: {
        titulo: "Editar comunidad",
        nomeComunidade: "Nombre de la comunidad",
        descricaoComunidade: "Descripción de la comunidad",
        comunidadeAtiva: "Comunidad activa:",
        cancelar: "Cancelar",
        salvarAlteracoes: "Guardar cambios"
      },
      criadoPor: "Creada por: ",
      criadoEm: "Creada en: ",
      membros: " miembros",
      membro: " miembro",
      topicos: " temas de discusión",
      editarComunidade: "Editar comunidad",
      enviando: "Enviando...",
      pedirParaEntrar: "Solicitar ser miembro",
      saindo: "Partida...",
      sairDaComunidade: "Dejar de ser miembro",
      listaREAs: "REAs da comunidad",
      descricaoREAs: 'Explora los recursos educativos de esta comunidad.',
      tutorialREAs: "Para añadir un REA a esta comunidad, accede al REA deseado y utiliza la opción 'Vincular'.",
      listaMembros: "Miembros de la comunidad",
      tutorialMembros: 'Para invitar a un nuevo miembro, accede a su perfil y utiliza la opción "Invitar a una comunidad".',
      descricaoMembros: "Conozca a los miembros de esta comunidad.",
      verPedidos: "Ver órdenes pendientes",
      modalPedidos: {
        titulo: "Pedidos pendientes",
        carregandoPedidos: "Libraciones de órdenes...",
        nenhumPedidoPendente: "No hay solicitudes pendientes.",
        solicitante: "Solicitante",
        dataPedido: "Fecha de solicitud",
        aceitar: "Aceptar",
        recusar: "Rechazar",
        pedido: "Pedido de"
      },
      forumComunidade: "Foro comunitario",
      descricaoForum: "Participe en discusiones comunitarias.",
      topico: "Tema",
      posts: "Postes",
      ultimoPost: "Última publicación",
      novoTopico: "Nuevo tema",
      modalTopico: {
        titulo: "Crear un nuevo tema",
        nomeTopico: "Tema",
        cancelar: "Cancelar",
        criar: "Crear",
        editarTitulo: 'Editar tema',
        salvar: 'Guardar cambios',
      },
      modalPosts: {
        tituloPrefix: "Publicaciones de temas",
        data: "Fecha",
        autor: "Autor",
        mensagem: "Mensaje",
        nenhumPost: "No se encontraron publicaciones.",
        novaMensagem: "Nuevo mensaje",
        postar: "Publicar",
        excluirTitulo: "Eliminar mensaje",
        excluirMensagem: "¿Está seguro de que desea eliminar este mensaje?",
        editarPost: 'Editar mensaje',
        excluirPost: 'Eliminar mensaje',
        editarTitulo: "Editar mensaje",
        carregarMaisMensagens: "Cargar más mensajes",
        carregandoMaisMensagens: "Cargando...",
      },
      confirmacoes: {
        desativarComunidade: "Realmente quieres deshabilitar la comunidad",
        reativarComunidade: "Realmente quieres reactivar la comunidad",
        sairComunidade: "¿Estás seguro de que quieres dejar esta comunidad?"
      },
      alertas: {
        pedidoEnviadoSucesso: "Orden enviado con éxito!",
        pedidoJaEnviado: "Ya ha enviado una solicitud a esta comunidad.",
        comunidadeNaoEncontrada: "Comunidad no encontrada.",
        erroPedido: "Error al enviar pedidos. Intentar otra vez.",
        saiuComSucesso: "Dejaste la comunidad con éxito.",
        membroNaoEncontrado: "Miembro no encontrado.",
        erroSair: "Error al salir de la comunidad. Intentar otra vez.",
        pedidoAceitoSucesso: "¡Acepto con éxito!",
        pedidoRecusado: "Rechazado.",
        erroAceitarPedido: "Error de aceptación de solicitud. Intentar otra vez.",
        erroRecusarPedido: "Error de rechazo de orden. Intentar otra vez.",
        conviteAceitoSucesso: "Invitación aceptada con éxito!",
        erroAceitarConvite: "Error al aceptar una invitación. Intentar otra vez.",
        erroRecusarConvite: "Error al rechazar la invitación. Intentar otra vez.",
        erroSalvarAlteracoes: "Los cambios de ahorro de errores. Intentar otra vez.",
        comunidadeDesativada: 'Esta comunidad ha sido desactivada.',
        topicoAtualizado: 'Tema actualizado con éxito.',
        erroAtualizarTopico: 'No se pudo actualizar el tema.',
        topicoExcluido: 'Tema eliminado con éxito.',
        erroExcluirTopico: 'No se pudo eliminar el tema.',
        topicoComMensagensEdicao: "Este tema ya tiene mensajes y no se puede editar.",
        topicoComMensagensExclusao: "Este tema ya tiene mensajes y no se puede eliminar.",
        topicoNaoEncontrado: "Tema no encontrado o ya eliminado.",
        erroExcluirMensagem: "No se pudo eliminar el mensaje.",
        erroExcluirMensagem: "No fue posible eliminar el mensaje.",
        tempoExclusaoExpirado: "El plazo (10 minutos) para eliminar este mensaje ya ha expirado.",
        postExcluidoSucesso: "Mensaje eliminado con éxito.",
        erroExcluirPostPermissao: "No tiene permiso para eliminar este mensaje.",
        tempoEdicaoExpirado: "El plazo (10 minutos) para editar este mensaje ya ha expirado.",
        erroEditarMensagem: "No fue posible editar el mensaje.",
        postEditadoSucesso: "Mensaje actualizado con éxito.",
        erroEditarPostPermissao: "No tiene permiso para editar este mensaje.",
        mensagemVazia: "El mensaje no puede estar vacío.",
        erroCarregarMaisMensagens: "No fue posible cargar más mensajes.",
      },
      editarTopico: "Editar tema",
      excluirTopico: "Eliminar tema",
      excluirTopicoTitulo: 'Eliminar tema',
      excluirTopicoMensagem: '¿Está seguro de que desea eliminar este tema? Esta acción no se puede deshacer.',
      diasAtras: 'día(s) atrás',
      horasAtras: 'hora(s) atrás',
      minAtras: 'min atrás',
      agora: 'ahora mismo',
    },

    chat: {
      placeholderMensagem: "Escribe tu mensaje...",
      enviar: "Enviar",
      naoFazMaisParte: "Ya no formas parte de esta sala. El envío de mensajes está deshabilitado.",
      saiu: "{nome} salió",
      foiRemovido: "{nome} fue eliminado",
      foiAdicionado: "{nome} fue añadido",
      usuarioGenerico: "Usuario"
    },

    chatApp: {
      criarSala: "Crear sala",
      novaConversa: "Nueva conversación",
      editarSala: "Editar sala",
      excluirSala: "Eliminar sala",

      confirmacaoExclusaoTitulo: "Confirmación",
      confirmacaoExclusaoMensagem: "¿Seguro que deseas eliminar esta conversación? Esta acción no se puede deshacer.",

      cancelar: "Cancelar",
      excluir: "Eliminar",

      naoTemPermissao: "No tienes permiso para eliminar esta sala.",
      erroExcluir: "No se pudo eliminar. Inténtalo de nuevo.",

      selecionarOuIniciar: "Selecciona una sala o inicia una conversación."
    },
    iniciarConversaModal: {
      titulo: "Iniciar conversación",
      placeholderBusca: "Escribe un nombre o palabra clave",
      nenhumUsuario: "No se encontró ningún usuario.",
      conversar: "Conversar"
    },
    gerenciarSala: {
      tituloCriar: "Crear nueva sala",
      avisoSomenteLeitura: "Ya no eres miembro de esta sala. Puedes ver el historial, pero no puedes editarla.",
      avisoConcorrencia: "La lista de participantes fue actualizada por otro usuario.",

      labelNomeSala: "Nombre de la sala",
      placeholderNomeSala: "Escribe el nombre de la sala",

      labelBusca: "Buscar colaboradores",
      placeholderBusca: "Escribe un nombre...",

      btnAdicionar: "Agregar",
      btnRemover: "Eliminar",

      nenhumSelecionado: "Ningún colaborador seleccionado.",

      btnCancelar: "Cancelar",
      btnCriarSala: "Crear sala",
      btnSalvarAlteracoes: "Guardar cambios"
    }
  }
}

const i18n = createI18n({
  legacy: false,           // desativa o modo legado pq usa a Composition API

  globalInjection: true,   // permite usar o $t diretamente nas templates
  locale: 'pt',
  fallbackLocale: 'en',
  messages,
})

export default i18n